import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { AxiosRequest, ImgURL, updateOptionsForUser, XMLrequest } from "../../../../Url";
import { Divider, GridLegacy, IconButton, Tooltip } from "@mui/material";
import Button from "@mui/material/Button";
import { createGrid, createRecordSource } from "../../../rcsgrid/rcsgrid";
import ReactDOM from "react-dom";
import {
  checkRightsFlag,
  defaultFieldInfo,
  getIcons,
  getKeyCodeOfInt,
  getRightsData,
  getStyleWindow,
  isEmptyObject,
  MenuItems,
  updateVisibleGrids,
} from "../../../Tools/Tools";
import ContextMenu, { GetDisable } from "../../../NotWorkArea(Side&Head)/ContextMenu";
import Menu from "@mui/material/Menu";
import LoadingMask from "../../../NotWorkArea(Side&Head)/LoadingMask";
import {
  CheckModalBackGrounds,
  getBase64ByFileReader,
  tokenProcessingTest,
} from "../../../../TokenProcessing/TokenProcessing";
import { FooterDataShow } from "../../../NotWorkArea(Side&Head)/Footer";
import SectionToolsJS from "../../../Tools/SectionToolsJS";
import TabsForReports from "../SectionReport/TabsForReports";
import DialogHtml from "../../../../Forms/DialogHtml";
import { CheckMultiSelect } from "../../../rcsgrid/createGridTools";
import Params from "../Params/Params";
import clsx from "clsx";
import IMemo from "../Forms/Components/IMemo";
import Tree from "../../../Windows/ViewData/Tree/Tree";
import { SequenceGetParams, setTreeGroup } from "../../../Tools/Requests";
import SmetaSplitter from "../../../Tools/Splitter/SmetaSplitter";
import SmetaSplitterItem from "../../../Tools/Splitter/SmetaSplitterItem";
import ButtonsForGridComponent from "../../../rcsgrid/GridTools/ButtonsForGridComponent";
import DocInfoAndSettings from "./DocInfoAndSettings";
import BackupTableIcon from "@mui/icons-material/BackupTable";
import DialogDocNumbering from "../../../Module/Dialogs/DialogDocNumbering";
import { smetaModals, SmetaModalsIdContext } from "../../../Tools/modalManager";
import { getLabelKeyCode } from "../../../Tools/KeyCods";
import Samples from "./Samples";
import { parseColumns } from "../../../rcsgrid/GridTools/parseColumnTools";
import SaveAsButton from "../../../Tools/SaveAsButton";
import { animationsAtom, currentTheme, smetaStore } from "../../../../../atoms";
import { beforeSaveState, saveDocChanges } from "./DocumentsConsts";
import Chat from "./ChatComponent/Chat";
import { Prefixes } from "../../../Tools/ProjectX";
import smetaAxios from "../../../../SmetaAxios";
import FunctionsIcon from "@mui/icons-material/Functions";
import { ViewClass } from "../../../Tools/Consts";
import SectionDocumentDetails, { flattenDocumentDetails } from "./SectionDocumentDetails";
import {
  createModalLeaveScope,
  createSectionLeaveScope,
  useLeaveBlocker,
  useLeaveRegistry,
} from "../../../Tools/leaveGuard";

const MenuJson = {
  Table: [
    { Caption: "Нумерация...", Disabled: false, value: "Numbering" },
    { Caption: "Сумма", Image: <FunctionsIcon fontSize="small" />, value: "calc" },
    { Caption: "Создать копию документа", value: "RecordCopy" },
    { Caption: "Сохранить как шаблон...", value: "Samples" },
    {
      Caption: "Детализация",
      Image: <BackupTableIcon fontSize="small" />,
      value: "Details",
    },
    {
      Caption: "Очистить состояние документа",
      items: [
        { Caption: "Сбросить все настройки документа", value: "ClearDocumentState" },
        { Caption: "Снять установленные фильтры", value: "clearAllFilters" },
      ],
    },
    { Caption: "Печать отмеченных записей", value: "PrintSelectedRecords" },
    // { Caption: "Открыть в другом окне", Disabled: true },
    // { Caption: "Открыть карточку", Disabled: true },
    // {
    //   Caption: "Копировать ссылку на документ",
    //   value: "CopyDocLink",
    //   Image: <LinkIcon fontSize="small" />,
    // },
    { Caption: "Divider" },
  ],
};

export async function getImageHint(doccfgId, index, docId) {
  let json;
  const params = new Map();
  params
    .set("prefix", "documents")
    .set("comand", "GetImageHint")
    .set("DocCfgID", doccfgId)
    .set("ImageIndex", index)
    .set("DocID", docId)
    .set("smart", "1");
  json = await AxiosRequest(true, params);
  return json.Text;
}

export function SaveDocumentState(doccfgId, id, state, activeDetails) {
  if (state) {
    const params = new Map();
    params
      .set("prefix", "documents")
      .set("comand", "SaveDocumentState")
      .set("DocCfgID", doccfgId)
      .set("SectionID", id)
      .set("ActiveDetail", activeDetails ? activeDetails + 1 : 0);
    AxiosRequest(true, params, { GridState: state });
  }
}

export function createGridStateString(gridState) {
  if (gridState) {
    let FinalStr = "";
    let valueForString;
    for (const [key, value] of Object.entries(gridState)) {
      if (value) {
        if (typeof value === "object") {
          valueForString = `${key}=`;
          for (const [keyPoint, data] of Object.entries(value)) {
            if (keyPoint === "9") {
              valueForString += `${data}`;
            } else {
              valueForString += `${data}•`;
            }
          }
        } else {
          valueForString = `${key}=${value}`;
        }
        FinalStr += valueForString + "\r\n";
      }
    }
    //
    return FinalStr;
  }
}

export function parseGridState(gridState) {
  if (gridState) {
    let arr = gridState.split("\r\n");
    let obj = {};
    if (arr.length > 0) {
      let valueForObj;
      for (const value of Object.values(arr)) {
        if (value !== "") {
          const ValueArr = value.split("=");
          if (ValueArr[1] && ValueArr[1].includes("•")) {
            valueForObj = Object.assign({}, ValueArr[1].split("•"));
          } else {
            valueForObj = ValueArr[1];
          }
          Object.assign(obj, { [ValueArr[0]]: valueForObj });
        }
      }
      return obj;
    }
  }
}

export default function SectionDocuments(props) {
  const documentLoadGeneration = useRef(0);
  const documentLayoutDocCfgId = useRef(undefined);
  const [DocumentLayout, setDocumentLayout] = useState(undefined); //Данные о основном гриде
  const [DocumentLayoutDetails, setDocumentLayoutDetails] = useState(undefined); //данные о гриде детализации документа
  const [detailsBool, setDetailsBool] = useState(props.detailsOpen !== undefined ? !props.detailsOpen : true); //вкл/выкл деталей
  const [selectedTabIndex, setSelectedTabIndex] = useState(0); // Активная вкладка детализации
  const [selectedRecordID, setSelectedRecordID] = useState(""); //ТЕкущая выбранная запись в гриде
  // Скрытые вкладки приходят с сервера и сразу влияют на список в SmetaTabs
  const [hiddenTabs, setHiddenTabs] = useState({});
  // Здесь храним данные модулей, которые теперь рендерятся обычным JSX
  const [detailModules, setDetailModules] = useState({});
  // Сохраняем размеры промежуточных панелей для детализации в детализации
  const [detailsSplittersSizes, setDetailsSplittersSizes] = useState({});
  // const [firstLoad, setFirstLoad] = useState(true); //Костыль для первой загрузки
  const [canModifyObj, setCanModifyObj] = useState({
    delete: true,
    insert: true,
  });
  // const [saveDocs, setSaveDocs] = useState({}); //храним doccfgid гридов, в которых меняли данные
  const [redactor, setRedactor] = useState(false);
  const [samples, setSamples] = useState([]);
  const [save, setSave] = useState({ [props.DocCfgID]: false });
  const [parentID, setParentID] = useState(props.ParentID ? props.ParentID : "0");
  const [tree, setTree] = useState(null);
  const [loadDetails, setLoadDetails] = useState(false);
  const [loadMain, setLoadMain] = useState(false);
  const [formsList, setFormsList] = useState([]);
  // const [sources, setSources] = React.useState({}); //тут сохраняем сурсы
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElButton, setAnchorElButton] = React.useState(null);
  const [selectedView, setSelectedView] = React.useState("doc"); // doc, paper, card какой вид сейчас у документа
  const [paperFormData, setPaperFormData] = React.useState({}); //основной грид
  // обновление истории параметров
  const [fixHistory, setFixHistory] = React.useState();
  const [paramPath, setParamPath] = React.useState();
  const [portal, setPortal] = React.useState([]);
  const [shortsCutsData, setShortsCutsData] = React.useState({});
  const [selectedViewIdent, setSelectedViewIdent] = React.useState("");
  const modalId = React.useContext(SmetaModalsIdContext);
  const leaveScope = modalId ? createModalLeaveScope(modalId) : createSectionLeaveScope(props.id);
  const { registerLeaveEffect } = useLeaveRegistry();
  useLeaveBlocker({
    id: `document-save:${props.DocCfgID}:${props.id}`,
    scope: leaveScope,
    enabled: Boolean(save[props.DocCfgID]),
    beforeUnload: true,
    canLeave: () => {
      return saveDocChanges({ docName: props.docName, saveChanges });
    },
  });
  const [controlButtonsState, setControlButtonsState] = React.useState({
    detail: detailsBool,
    card: false,
    filter: false,
  });
  const [controlButtons, setControlButtons] = React.useState({
    navigate: true,
    delete: true,
    save: true,
    card: true,
    create: true,
    createList: true,
    editButtons: true,
    detail: true,
    sign: true,
    refreshFull: true,
    filter: true,
    print: false,
  });
  // const theme = useSelector((state) => state.theme.theme);
  // const [options, setOptions] = useState({ filter: false, groupby: false }); //какие опции вкл/выкл
  const MainGridRef = useRef(null); //грид основной
  const focusedGridRef = useRef(null);
  const SubGridRef = useRef(null); //грид детализации
  const timeoutUpdateGrid = useRef(null);
  // Поколения помогают не применить ответ от уже устаревшего запроса
  const detailsLayoutGeneration = useRef(0);
  const detailsContentGeneration = useRef(0);
  const documentLayoutDetailsRef = useRef(undefined);
  const detailsContext = useRef(undefined);
  const detailsRequest = useRef(undefined);
  const detailsRefresh = useRef(undefined);
  const currentDocumentHandlers = useRef({});
  const sources = useRef({});
  const saveDocs = useRef({});
  const me = useRef(null);
  const applyButton = useRef(null);
  const redactorRef = useRef(false);
  const formidRef = useRef(null);
  const leftSplitterRef = useRef(null);
  const parentIDStorage = useRef({ needUpdt: true });
  const hiddenTabsRef = useRef({});

  var grid = null;

  // Используем одно и то же представление вкладок во всех обработчиках
  const getDetailTabs = (layout = currentDocumentHandlers.current.layout) =>
    flattenDocumentDetails(layout && layout.Details ? layout.Details : layout, hiddenTabsRef.current);

  // Индекс может устареть после скрытия вкладки, поэтому всегда ограничиваем его списком
  const getActiveDetailTab = (
    index = currentDocumentHandlers.current.tabIndex,
    layout = currentDocumentHandlers.current.layout,
  ) => {
    const detailTabs = getDetailTabs(layout);
    if (detailTabs.length === 0) return undefined;
    return detailTabs[Math.max(0, Math.min(Number(index) || 0, detailTabs.length - 1))];
  };

  const getActiveDetailContent = () => {
    // DOM-контейнер нужен старым функциям обновления размера legacy-грида
    const activeTab = getActiveDetailTab();
    return activeTab ? me.current?.querySelector(`#details${activeTab.docCfgID}`) : undefined;
  };

  const updateDetailModule = (docCfgID, moduleData) => {
    // Обновляем только нужную вкладку и не затрагиваем уже открытые модули
    setDetailModules((current) => ({ ...current, [docCfgID]: moduleData }));
  };

  const refreshActiveDetails = async () => {
    const generation = documentLoadGeneration.current;
    const source = MainGridRef.current?.grid?.getActiveSource();
    const detailTab = getActiveDetailTab();
    if (!source || !detailTab) return;
    const masterID = source.getFieldTextSync("ID");
    const pending = detailsRefresh.current;
    if (pending?.source === source && pending.docCfgID === detailTab.docCfgID && pending.masterID === masterID) {
      return pending.promise;
    }
    const refresh = async () => {
      const context = detailsContext.current;
      if (context?.docCfgID !== detailTab.docCfgID || context.masterID !== masterID) {
        await onTabChange(currentDocumentHandlers.current.tabIndex, detailTab);
      }
      if (
        generation === documentLoadGeneration.current &&
        source === MainGridRef.current?.grid?.getActiveSource() &&
        getActiveDetailTab()?.docCfgID === detailTab.docCfgID &&
        source.getFieldTextSync("ID") === masterID &&
        documentLayoutDetailsRef.current
      ) {
        await UpdDetails(currentDocumentHandlers.current.tabIndex, documentLayoutDetailsRef.current);
      }
    };
    const promise = refresh();
    const request = { source, docCfgID: detailTab.docCfgID, masterID, promise };
    detailsRefresh.current = request;
    try {
      await promise;
    } finally {
      if (detailsRefresh.current === request) detailsRefresh.current = undefined;
    }
  };

  const handleMainRecordIndexChanged = async (source) => {
    if (source !== MainGridRef.current?.grid?.getActiveSource()) return;
    const id = await source.getFieldText("ID");
    setSelectedRecordID(id === "" ? "0" : id);
    await currentDocumentHandlers.current.refreshDetails();
  };

  const refreshDocumentToken = async () => {
    await MainGridRef.current.grid.refreshSource("!");
    await currentDocumentHandlers.current.refreshDetails();
    await currentDocumentHandlers.current.updateButtons();
  };

  currentDocumentHandlers.current = {
    docCfgID: props.DocCfgID,
    layout: DocumentLayout,
    tabIndex: selectedTabIndex,
    refreshDetails: refreshActiveDetails,
    updateButtons: updStateOfButtons,
    onTabChange,
  };

  useEffect(() => {
    if (me.current) {
      me.current.refreshMainGrid = (data) => refreshMainGrid(data);
      me.current.CommitSaveOrCancelChanges = (comand) => CommitSaveOrCancelChanges(comand);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me.current]);

  // Получаем выбоанный документ, запрашиваем для него данные и отрисовываем грид на основе данных
  useEffect(() => {
    documentLoadGeneration.current++;
    // При смене документа сбрасываем все данные прошлой детализации
    setDocumentLayout(undefined);
    setDetailModules({});
    setHiddenTabs({});
    hiddenTabsRef.current = {};
    documentLayoutDetailsRef.current = undefined;
    detailsContext.current = undefined;
    detailsRequest.current = undefined;
    detailsRefresh.current = undefined;
    detailsLayoutGeneration.current++;
    detailsContentGeneration.current++;
    const loadTimeout = setTimeout(() => {
      if (!props.DocCfgID) return;
      if (redactor) {
        redactor.cancelRecord();
      }
      // console.log(webkcrypt);
      ClearDocumentStatus().catch((error) => {
        console.error("Не удалось загрузить документ", error);
        setLoadMain(false);
      });
      updateOptionsForUser({
        Selected: {
          docid: props.DocCfgID === undefined ? undefined : selectedRecordID,
          DocCfgID: props.DocCfgID,
        },
      });
      // setDetailsBool(true);
    }, 750);
    return () => {
      clearTimeout(loadTimeout);
      documentLoadGeneration.current++;
      detailsLayoutGeneration.current++;
      detailsContentGeneration.current++;
      clearTimeout(timeoutUpdateGrid.current);
      setDocumentLayout(undefined);
      setDocumentLayoutDetails(undefined);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.DocCfgID]);

  useEffect(() => {
    if (MainGridRef.current && MainGridRef.current.grid && DocumentLayout?.HasTree === "1") {
      if (parentID !== undefined) {
        const treeProps = getDocumentTreeProps();
        setTreeGroup(treeProps.Module, treeProps.ObjType, treeProps.SectionID, parentID);
        MainGridRef.current.grid.getActiveSource().onHandleRequest = onHandleRequestDocuments(
          props.DocCfgID,
          DocumentLayout.TreeInConfig === "1" ? "0" : parentID,
        );
      }
      ApplyButtonClick();
    }
    if (parentIDStorage.current.needUpdt) {
      parentIDStorage.current.id = parentID;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentID]);

  // Обновлении деталей при смене выбранной записи в гриде
  useLayoutEffect(() => {
    async function asyncFunc() {
      if (selectedView === "paper") {
        setTimeout(() => {
          PaperForm();
        }, 0);
      }
      updStateOfButtons();
    }
    asyncFunc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRecordID]);

  useEffect(() => {
    //меняем данные в футере, в зависимости от выбранной записи(пока только на основной грид)
    FooterMultiOrData(MainGridRef.current.grid);
  }, [selectedRecordID]);

  useEffect(() => {
    if (selectedView === "doc") {
      TestUpdateGrid();
    }
  }, [selectedView]);

  useEffect(() => {
    if (MainGridRef.current.grid && MainGridRef.current.grid.source) {
      if (controlButtonsState.detail !== detailsBool)
        setControlButtonsState({
          ...controlButtonsState,
          detail: detailsBool,
          card: MainGridRef.current.grid.isCard(),
          filter: MainGridRef.current.grid.filter.style.display === "grid",
        });
      MainGridRef.current.grid.getActiveSource().details = {
        ...MainGridRef.current.grid.getActiveSource().details,
        activeDetails: selectedTabIndex,
        detailsBool: detailsBool,
      };
      MainGridRef.current.grid.updateStateValues();
      MainGridRef.current.grid.refreshDocumentToken = refreshDocumentToken;
    }
  }, [selectedTabIndex, detailsBool]);

  // При изменеии хука перерисовываем грид
  useLayoutEffect(() => {
    // Не создаём грид из layout предыдущего документа при смене props.
    if (DocumentLayout && documentLayoutDocCfgId.current === props.DocCfgID) {
      const generation = documentLoadGeneration.current;
      CreateGrid(MainGridRef.current, {
        id: props.id,
        who: "Documents",
        DocCfgID: props.DocCfgID,
        state: setSelectedRecordID,
        Columns: DocumentLayout.Columns,
        Which: true,
        detailsBoolLocal: DocumentLayout.detailsBoolLocal,
      })
        .then(async (source) => {
          if (!source || generation !== documentLoadGeneration.current) return;
          const idselected = await source.getFieldText("ID");
          if (generation !== documentLoadGeneration.current) return;
          setSelectedRecordID(idselected === "" ? "0" : idselected);
        })
        .catch((error) => {
          if (generation !== documentLoadGeneration.current) return;
          console.error("Не удалось создать грид документа", error);
          setLoadMain(false);
        });
      ButtonsForDocuments(DocumentLayout.Tools.Buttons, {
        //берем кнопки и рисуем их
        DocCfgID: props.DocCfgID,
        from: "main",
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [DocumentLayout]);

  useEffect(() => {
    if (DocumentLayout) {
      MainGridRef.current.focus();
    }
  }, [MainGridRef]);

  useEffect(() => {
    redactorRef.current = redactor;
    document.removeEventListener("click", clickAwayForRedactor, true);
  }, [redactor]);

  useEffect(() => {
    if (DocumentLayoutDetails && MainGridRef.current?.grid?.source) {
      currentDocumentHandlers.current.refreshDetails().catch((error) => {
        console.error("Не удалось обновить детализацию", error);
        setLoadDetails(false);
      });
    }
  }, [DocumentLayoutDetails]);

  function refreshMainGrid(data) {
    if (!MainGridRef.current?.grid?.source) return;
    MainGridRef.current.grid.getActiveSource().onHandleRequest = onHandleRequestDocuments(data.DocCfgID, data.ParentID);
    MainGridRef.current.grid.setSource(MainGridRef.current.grid.source);
    MainGridRef.current.grid.source.first();
    MainGridRef.current.grid.refreshSource();
    MainGridRef.current.grid.updateGridSize();
    setParentID(data.ParentID);
  }

  async function updStateOfButtons() {
    if (MainGridRef.current.grid) {
      updateOptionsForUser({
        Selected: { docid: selectedRecordID, DocCfgID: props.DocCfgID },
      });
      setCanModifyObj({
        delete: !(await MainGridRef.current.grid.canModify(2, undefined, MainGridRef.current.grid)),
        insert: !(await MainGridRef.current.grid.canModify(0, undefined, MainGridRef.current.grid)),
      });
      MainGridRef.current.grid.refreshDocumentToken = refreshDocumentToken;
    }
  }

  function parseShortsCuts(Tools = {}) {
    let buttonsData = { Buttons: Tools.Buttons, Menu: Tools.Menu };
    if (Tools.Buttons) buttonsData.Buttons = parseShortCut(Tools.Buttons);
    if (Tools.Menu) buttonsData.Menu = parseShortCut(Tools.Menu);
    return buttonsData;
  }

  function parseShortCutsForKeyDown(Tools = {}, doccfgid, updateAll) {
    let onlyShortCuts = updateAll !== undefined ? updateAll : shortsCutsData;
    if (Tools.Buttons)
      onlyShortCuts = {
        ...parseShortCut(Tools.Buttons, doccfgid),
        ...onlyShortCuts,
      };
    if (Tools.Menu)
      onlyShortCuts = {
        ...parseShortCut(Tools.Menu, doccfgid),
        ...onlyShortCuts,
      };
    if (updateAll !== undefined) {
      return onlyShortCuts;
    } else setShortsCutsData(onlyShortCuts);
  }

  function updAllShortsCut(DocumentLayoutDetails, doccfgidDetails) {
    let onlyShortCuts = {};
    onlyShortCuts = parseShortCutsForKeyDown(DocumentLayout.Tools, props.DocCfgID, true);
    onlyShortCuts = {
      ...onlyShortCuts,
      ...parseShortCutsForKeyDown(DocumentLayoutDetails.Tools, doccfgidDetails, onlyShortCuts),
    };
    setShortsCutsData(onlyShortCuts);
  }

  const parseShortCut = (Tool, localdoccfgid) => {
    if (localdoccfgid !== undefined) {
      let returnArr = {};
      for (const value of Object.values(Tool)) {
        if (value.ShortCut) {
          let parsed;
          if (typeof value.ShortCut === "object") {
            parsed = value.ShortCut;
          } else {
            parsed = getKeyCodeOfInt(Number(value.ShortCut));
          }
          returnArr = {
            ...returnArr,
            [[parsed]]: {
              ...value,
              ShortCut: parsed,
              ShortCutString: getLabelKeyCode(parsed),
              localdoccfgid,
            },
          };
        }
      }
      return returnArr;
    } else {
      return Tool.map((val) => {
        if (val.ShortCut) {
          const parsed = getKeyCodeOfInt(Number(val.ShortCut));
          return {
            ...val,
            ShortCut: parsed,
            ShortCutString: getLabelKeyCode(parsed),
          };
        } else return val;
      });
    }
  };

  function getTheme() {
    return smetaStore.get(currentTheme);
  }

  async function clickAwayForRedactor(e) {
    const closestGrid = e.target.closest(".grid-panel");
    if (redactorRef.current && closestGrid && closestGrid.grid.doccfgid === redactorRef.current.doccfgid) return;
    if (
      e.target.tagName === "BODY" ||
      e.target.closest("[loadmask]") ||
      e.target.classList.contains("MuiBackdrop-root") ||
      e.target.closest("[componenteditor]") ||
      e.target.closest("[checklist]") ||
      e.target.closest("[calendar]") ||
      e.target.closest("[details]") ||
      e.target.closest("UL") ||
      (e.target.closest(".background_ModalDialog") && !me.current.closest(".background_ModalDialog"))
    ) {
      return;
    }
    if (redactorRef.current && !e.target.closest(".CloseButtonForGrid") && !e.target.closest(".ApplyButtonForGrid")) {
      await redactorRef.current.postExicstedEditRec();
    }
    document.removeEventListener("click", clickAwayForRedactor, true);
  }

  async function FooterMultiOrData() {
    if (props.DocCfgID && focusedGridRef.current && focusedGridRef.current.grid) {
      const grid = focusedGridRef.current.grid;
      const activeSource = grid.getActiveSource();
      const selectedRecIndex = activeSource.activeRecord;
      const multiSelectCount = grid.getMultiSelect().length,
        arrtoShow = [`Всего: ${activeSource.recordCount}`];
      if (multiSelectCount > 0) {
        arrtoShow.push(`Выделено: ${multiSelectCount}`);
      } else {
        const dataAboutRecord = {
          updateUser: await activeSource.getFieldText("UpdateUser", selectedRecIndex),
          updTime: await activeSource.getFieldText("UpdateTime", selectedRecIndex),
        };
        arrtoShow.push(
          `Изменен ${dataAboutRecord.updTime ? dataAboutRecord.updTime : ""} (${
            dataAboutRecord.updateUser ? dataAboutRecord.updateUser : ""
          })  `,
        );
      }
      FooterDataShow(props.id, arrtoShow, props.footerID);
    }
  }

  function addButtonsForSectionTools(resButtons, newButtons) {
    if (resButtons) {
      return [...newButtons, ...resButtons];
    }
  }

  function getDefaultButtonsforSectionTools() {
    return [
      {
        ID: "-10",
        Hint: "Видимость левой боковой панели",
        Image: getIcons("35"),
      },
    ];
  }

  const ClearDocumentStatus = async (refresh) => {
    // Кнопка отчиски статуса документа или первая отрисовка грида
    if (props.DocCfgID) {
      const generation = ++documentLoadGeneration.current;
      setLoadMain(true);
      const res = await GetDocumentLayout(props.DocCfgID, undefined, refresh);
      if (generation !== documentLoadGeneration.current) return;
      if (refresh && sources.current[props.DocCfgID]) {
        MainGridRef.current.grid.getActiveSource().setGridState({});
        await refreshFullDocument(true);
        if (generation !== documentLoadGeneration.current) return;
      }
      let gridState,
        activeDetails = 0,
        detailsBoolLocal = detailsBool,
        DetailsSplittersSizes = undefined,
        ParsedTools;
      ParsedTools = parseShortsCuts(res.Tools, props.DocCfgID);
      res.Tools = ParsedTools;
      if (res.Samples && res.Samples.items) {
        setSamples(res.Samples.items);
      }
      // доп кнопки для секции инструментов
      res.Tools.Buttons = addButtonsForSectionTools(res.Tools.Buttons, getDefaultButtonsforSectionTools());
      setFormsList(res.Forms);
      parseShortCutsForKeyDown(res.Tools, props.DocCfgID);
      if (res.GridState) {
        gridState = parseGridState(res.GridState);
        if (gridState.details) {
          const details = JSON.parse(gridState.details);
          detailsBoolLocal = details.detailsBool;
        }
        // activeDetails = gridState.ShowDetail;
      }
      if (sources.current[props.DocCfgID] && sources.current[props.DocCfgID].source.details) {
        activeDetails = Number(sources.current[props.DocCfgID].source.details.activeDetails);
        detailsBoolLocal = sources.current[props.DocCfgID].source.details.detailsBool;
        DetailsSplittersSizes = sources.current[props.DocCfgID].source.details.DetailsSplittersSizes;
      } else {
        activeDetails = Number(res.ActiveDetail) - 1;
      }
      activeDetails = isNaN(activeDetails) ? 0 : activeDetails;

      // path для запроса истории параметров
      if (res && res.Params && res.Params.Path) setParamPath(res.Params.Path);

      // setDocumentLayout({ ...res, GridState: gridState });
      setSelectedView("doc"); //для работы печатной формы
      setSelectedViewIdent("");
      formidRef.current = null;
      documentLayoutDocCfgId.current = props.DocCfgID;
      setDocumentLayout({
        ...res,
        GridState: gridState,
        detailsBoolLocal: detailsBoolLocal,
      });
      if (props.HideDetails) {
        setDetailsBool(true);
        setTree(getTree(res));
        return;
      }
      let indexOfDetails = undefined;
      if (!isEmptyObject(res.Details)) {
        for (const [index, detail] of Object.entries(res.Details.items)) {
          if (detail.Hidden !== "1") {
            indexOfDetails = Number(index);
            break;
          }
        }
      }
      if (indexOfDetails !== undefined) {
        if (activeDetails !== undefined) indexOfDetails = activeDetails;
        const detailTabs = flattenDocumentDetails(res.Details, hiddenTabsRef.current);
        indexOfDetails = Math.max(0, Math.min(indexOfDetails, detailTabs.length - 1));
        const detailsdataFromActiveDetails = detailTabs[indexOfDetails];
        if (!detailsdataFromActiveDetails) {
          setDetailsBool(true);
          setTree(getTree(res));
          return;
        }
        setSelectedTabIndex(indexOfDetails);
        setDetailsSplittersSizes(DetailsSplittersSizes || {});
        // DisplaySplitterDetaild("show");
        await onTabChange(indexOfDetails, detailsdataFromActiveDetails);
        if (generation !== documentLoadGeneration.current) return;

        if (!detailsBoolLocal && !props.HideControlButtons) ChangeCollapsedDetails(detailsBoolLocal);
        // UpdDetails(activeDetails, resDetails)
      } else {
        setDetailsBool(true);
      }
      setTree(getTree(res));
    }
  };

  // Делаем правильныую высоту вертикальных сплиттеров при первом рендере
  // FixSplitterHeight();

  // Рисуем кнопки для документа
  function ButtonsForDocuments(json, subData) {
    let items = [],
      iconbutton,
      buttonsBlock =
        props.buttonsContainerRef && props.buttonsContainerRef.current
          ? props.buttonsContainerRef.current
          : document.getElementById("buttons_for_section" + props.id);
    if (json !== undefined && !isEmptyObject(json) && buttonsBlock) {
      for (const [key, value] of Object.entries(json)) {
        if (value.Caption !== "-") {
          // проверка на разделитель |
          let hintForButton = value.Hint;
          if (value.ShortCutString) {
            hintForButton += ` (${value.ShortCutString})`;
          }
          iconbutton =
            value.Width && value.Caption !== undefined ? ( //если есть ширина, то рисуем обычную кнопку а не айкон баттон
              <Button
                id={value.ID}
                from={subData.from}
                style={{
                  width: value.Width === undefined ? "" : `${value.Width * 1.286}px`,
                  fontSize: "13px",
                  textTransform: "none",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
                component="span"
                disabled={value.Disabled === "1"}
                index={key}
                doccfgid={props.DocCfgID}
                key={key}
                onClick={
                  (event) => {
                    value.items ? setAnchorElButton(event.currentTarget) : HandleToolButton(event);
                  }
                  //условия для выпадающего списка из кнопки
                }
                startIcon={ImgURL(value.Image)}
              >
                {value.Caption === undefined ? "" : ` ${value.Caption}`}
              </Button>
            ) : (
              <IconButton
                id={value.ID}
                from={subData.from}
                key={key}
                variant="text"
                style={{
                  width: value.Caption === undefined ? "40px" : `${value.Width}px`, //value.Width === undefined ||
                  fontSize: "13px",
                }}
                component="span"
                doccfgid={props.DocCfgID}
                index={key}
                disabled={value.Disabled === "1"}
                onClick={(event) => {
                  value.items ? setAnchorElButton(event.currentTarget) : HandleToolButton(event);
                }}
              >
                {ImgURL(value.Image, { marginLeft: "0px" })}
                {value.Caption === undefined ? "" : ` ${value.Caption}`}
              </IconButton>
            );
          items.push(
            <GridLegacy key={key} item documentsectionbutton="">
              {value.Hint ? (
                <Tooltip title={hintForButton} arrow>
                  {iconbutton}
                </Tooltip>
              ) : (
                iconbutton
              )}
            </GridLegacy>,
          );
        } else {
          items.push(<Divider key={key} orientation="vertical" flexItem sx={{ mr: 0.5 }} />);
        }
      }
      setPortal(ReactDOM.createPortal(items, buttonsBlock));
    }
  }

  function customClick(id) {
    switch (id) {
      case "-10":
        if (!leftSplitterRef.current) return;
        const state = leftSplitterRef.current.querySelector(`div[role="separator"]`);
        if (!state) return;
        if (state.hasAttribute("data-itemcollapsed")) {
          leftSplitterRef.current.expand(true, 0);
        } else {
          leftSplitterRef.current.collapse(true, 0);
        }

        break;
      default:
        break;
    }
  }

  // Запрос-клик на кнопку для документа
  function HandleToolButton(event, gridRef) {
    if (event.currentTarget.id <= -10) {
      customClick(event.currentTarget.id);
      return;
    }
    setAnchorElButton(null);
    const focusId = focusedGridRef.current.grid.doccfgid;

    let params = new Map(),
      gridToHandle = gridRef ? gridRef : MainGridRef.current,
      mainGrid = MainGridRef.current.grid,
      DocID,
      MainDocID,
      doccfgId,
      isDetails = false;
    DocID = gridToHandle.grid.getActiveSource().getFieldTextSync("ID");
    MainDocID = mainGrid.getActiveSource().getFieldTextSync("ID");
    doccfgId = gridToHandle.grid.doccfgid === "0" ? props.DocCfgID : gridToHandle.grid.doccfgid;
    isDetails =
      gridToHandle &&
      gridToHandle.grid &&
      gridToHandle.grid.getActiveSource().Master &&
      gridToHandle.grid.getActiveSource().Master.MasterID;
    params.set("prefix", "documents");
    params.set("comand", "HandleToolButton");
    params.set("ID", event.currentTarget.id);
    params.set("DocID", DocID ? DocID : 0);
    params.set("DocCfgID", props.DocCfgID);
    params.set("SectionID", props.id);
    console.log(gridToHandle);
    params.set("MasFld", mainGrid.getSelectedField());
    params.set("PlaneView", mainGrid.isCard() ? "1" : "0");
    params.set("focus", focusId);
    params.set("WSM", "1");
    if (isDetails) {
      params.set("MasterID", gridToHandle.grid.getActiveSource().Master.MasterID);
      params.set("ActiveDetail", gridToHandle.grid.doccfgid);
      params.set("DetailID", DocID ? DocID : 0);
      // params.set("Details", "");//SELECTION
      params.set("DetailsFld", gridToHandle.grid.getSelectedField());
    }

    if (mainGrid.getMultiSelect().length > 0) {
      CheckMultiSelect(mainGrid).then((selection) => {
        params.set("Selection", selection);
        AfterSelection();
      });
    } else {
      AfterSelection();
    }
    function AfterSelection(passed) {
      if (isDetails && gridToHandle.grid.getMultiSelect().length > 0 && passed === undefined) {
        CheckMultiSelect(gridToHandle.grid).then((selection) => {
          params.set("Details", selection); //SELECTION
          AfterSelection(true);
        });
      } else {
        AxiosRequest(true, params).then((res) => {
          tokenProcessingTest(res, {
            from: "grid",
            func: (data) => AfterWSM(gridToHandle, data),
          });
        });
      }
    }
  }

  async function AfterWSM(gridRef, data = {}) {
    if (currentDocumentHandlers.current.docCfgID !== props.DocCfgID || !gridRef?.isConnected || !gridRef.grid) return;
    await gridRef.grid.refreshSource(data.DocID || "!");
    await currentDocumentHandlers.current.refreshDetails();
    await currentDocumentHandlers.current.updateButtons();
    if (props.master) await props.master.refreshRecord();
  }

  // Функция установки полей для грида
  function setCollumsForGrid(Columns, grid) {
    // не показывать в списке 256(отображение в таблице и списке колонок) Options
    if (Columns) {
      const columns = parseColumns(
        { Columns: Columns },
        {
          Module: "documents",
          docOpts: true,
          widthMultiply: 1.33,
        },
      );

      grid && grid.setColumns(columns, true);
      return columns;
    } else grid.defaultColumns = true;
  }

  function canModify(flag, column, grid) {
    // dd - детали в деталях, что бы понять когда не нужно возвращаться false
    // 0 - добавление записей, 2 - удаление записей, 1 - изменять значения, 3 - вставка через буфер
    //mfInsert = 0, mfDelete = 2, mfEdit = 1, mfPaste = 3,

    if (props.sectionRights && !checkRightsFlag(props.sectionRights, flag)) return false;
    const isEmptySource = grid.getActiveSource().recordCount === 0;
    const source = grid.getActiveSource();
    const recordInfo = grid.getActiveSource().getRecordInfo();

    let canModify = true,
      lockStatus = recordInfo.LockStatus,
      localFlag = flag;
    const insertFlagDisable = 1,
      onlyViewMode = grid.OnlyViewMode,
      mfInsert = 0,
      mfEdit = 1,
      mfDelete = 2,
      mfPaste = 3,
      byteRights = {
        [mfInsert]: 1,
        [mfEdit]: 2,
        [mfDelete]: 4,
      };

    if ((grid.detailsInDetail === true && !grid.textField) || onlyViewMode) {
      return false;
    }

    if (!isEmptyObject(recordInfo)) {
      if (!isEmptyObject(source)) {
        switch (flag) {
          case mfPaste:
          case mfInsert: //добавление записей или вставка
            if (canModify) canModify = !grid.getActiveSource().Master.isEmpty; //проверка на сурс мастер
            if (canModify) canModify = grid.getActiveSource().rights.insert; //Проверка прав
            if (canModify) canModify = grid.getActiveSource().InsertFlag !== insertFlagDisable; //Проверка запрета из getFields
            if (canModify && flag === mfPaste) canModify = canModify;
            if (canModify) canModify = (lockStatus & byteRights[mfInsert]) === 0; //битовое сравение с флагом insert
            break;
          case mfEdit: // редактирование записей
            if (column && column.fieldName) {
              const indexOfField = grid.getActiveSource().getFieldIndex(column.fieldName);
              const locking = recordInfo.Data$content;
              canModify = locking[indexOfField] === "0" || locking[indexOfField] === "4";
            } else canModify = (lockStatus & byteRights[mfEdit]) === 0;
            break;
          case mfDelete: //удаление
            canModify = grid.getActiveSource().rights.delete;
            if (canModify && lockStatus & 4) canModify = false;
            if (canModify && grid.getActiveSource().recordCount === 0) canModify = false;
            break;
        }
      }
    } else {
      if (localFlag === mfEdit && isEmptySource) localFlag = mfInsert;
      if ([mfInsert, mfPaste].includes(localFlag)) {
        const sourceInsertFlags = {
          insertFlagDisable: () => (canModify = false),
          2: () => (canModify = true),
        };
        if (sourceInsertFlags[source.InsertFlag]) {
          canModify = sourceInsertFlags[source.InsertFlag]();
        } else {
          lockStatus = 0;
          const sourceMasterRecordInfo = source.Master.source && source.Master.source.getRecordInfo();
          if (!isEmptyObject(sourceMasterRecordInfo) && sourceMasterRecordInfo.LockStatus) {
            lockStatus = sourceMasterRecordInfo.LockStatus;
          }
        }
        canModify = (lockStatus & byteRights[mfEdit]) === 0;
        if (canModify) canModify = !grid.getActiveSource().Master.isEmpty;
      } else canModify = false;
    }
    return canModify;
  }

  // Создание грида с сохранением сурса
  async function CreateGrid(gridPanel, data) {
    const generation = documentLoadGeneration.current;
    let source,
      dcfg = data.DocCfgID;
    if (sources.current[dcfg] && sources.current[dcfg].source) {
      //проверяем есть ли у нас уже сохраненный сурс
      grid = gridPanel.grid;
      if (grid.isCard()) {
        await grid.Rotate("", false);
        if (generation !== documentLoadGeneration.current) return;
      }
      source = sources.current[dcfg].source;
      setCollumsForGrid(data.Columns, gridPanel.grid);
      grid.BkClrField = DocumentLayout.BkClrField;
      grid.ColorField = DocumentLayout.ColorField;
      grid.StyleField = DocumentLayout.StyleField;
      grid.doccfgid = data.DocCfgID;
      grid.setImageFields(DocumentLayout.ImageFields);
      await grid.setSource(source);
      if (generation !== documentLoadGeneration.current) return;
      grid.doccfgid = data.DocCfgID;
      // setDetailsBool(sources.current[dcfg].details);
      source.onRecordIndexChanged = handleMainRecordIndexChanged;
      source.onDataChanged = () => currentDocumentHandlers.current.refreshDetails();
      const gridStateFromSource = source.getGridState();
      if (gridStateFromSource && gridStateFromSource.ViewMode === "1") {
        await grid.Rotate();
        if (generation !== documentLoadGeneration.current) return;
      }
      setControlButtons({
        ...controlButtons,
        sign: source.findField("Doc$DSign"),
      });
      FooterDataShow(
        props.id,
        [
          `Число записей: ${source.recordCount}`,
          `Изменен ${await source.getFieldText("UpdateTime")} (${await source.getFieldText("UpdateUser")})  `,
        ],
        props.footerID,
      );
      props.setRecorcCount && props.setRecorcCount(source.recordCount);
    } else {
      source = new createRecordSource();
      source.onHandleRequest = onHandleRequestDocuments(data.DocCfgID, data.ParentID);
      source.details = {
        activeDetails: selectedTabIndex,
        detailsBool: data.detailsBoolLocal,
      };
      source.Master = {
        ...props.master,
      };
      if (!gridPanel.grid || !data.Which) {
        gridPanel.grid = new createGrid(gridPanel);
        gridPanel.grid.onButtonsStateChange = onButtonsStateChange;
        gridPanel.grid.canModify = canModify;
      }
      gridPanel.grid.doccfgid = props.DocCfgID;
      grid = gridPanel.grid;
      if (grid.isCard()) {
        await grid.Rotate("", false);
        if (generation !== documentLoadGeneration.current) return;
      }
      setCollumsForGrid(data.Columns, gridPanel.grid);

      grid.BkClrField = DocumentLayout.BkClrField;
      grid.ColorField = DocumentLayout.ColorField;
      grid.StyleField = DocumentLayout.StyleField;
      grid.doccfgid = data.DocCfgID;
      grid.setImageFields(DocumentLayout.ImageFields);
      if (DocumentLayout.GridState && props.disiableState !== true) {
        source.setGridState(DocumentLayout.GridState);
      }
      // source.details = {
      //   activeDetails: selectedTabIndex,
      //   detailsBool: detailsBool,
      // };
      // await source.open();
      if (DocumentLayout.Rights) {
        source.rights = getRightsData(DocumentLayout.Rights);
      }
      const stateCallbackKey = `state${dcfg}${props.id}`;
      const callBack = () => {
        return beforeSaveState({
          source: grid.getActiveSource(),
          dcgid: dcfg,
          secId: props.id,
        });
      };
      source.onGridStateChange = () =>
        registerLeaveEffect({
          id: stateCallbackKey,
          scope: leaveScope,
          run: callBack,
        });
      source.onRecordIndexChanged = handleMainRecordIndexChanged;
      source.onDataChanged = () => currentDocumentHandlers.current.refreshDetails();
      grid.onMultiSelectChange = function (grid) {
        FooterMultiOrData(grid);
      };
      grid.onRecordCountChange = function (grid) {
        FooterMultiOrData(grid);
      };
      source.onNeedToSaveChanged = function (source) {
        //изменяем массив с гридами, которые нужно сохранить
        onNeedToSaveChanged(grid);
      };
      grid.CommitToSaveChanges = function (data) {
        if (props.setRedactor) {
          props.setRedactor(data);
        } else {
          if (data) document.addEventListener("click", clickAwayForRedactor, true);
          setRedactor(data);
        }
      };
      const detailsBoolLocal =
        sources.current[dcfg] && sources.current[dcfg].details ? sources.current[dcfg].details : true;
      sources.current = {
        ...sources.current,
        [data.DocCfgID]: {
          source: source,
          details: detailsBoolLocal,
          sourcesDetail: {},
        },
      };
      grid.statusData = {
        handleStatuses: () => {
          return AxiosRequest(true, DocumentRequest({ command: "GetStatusList" }));
        },
        changeStatus: changeStatus,
      };
      await grid.setSource(source);
      if (generation !== documentLoadGeneration.current) return;
      if (DocumentLayout.GridState) {
        if (DocumentLayout.GridState.ViewMode === "1") {
          grid.OnlyViewMode = true;
        }
      }
      if (props.ObjRef) {
        await grid.refreshSource("^" + props.ObjRef);
        if (generation !== documentLoadGeneration.current) return;
      } else {
        await grid.refreshSource();
        if (generation !== documentLoadGeneration.current) return;
      }
      await updStateOfButtons();
      if (generation !== documentLoadGeneration.current) return;
      if ((DocumentLayout.GridState && DocumentLayout.GridState.CardMode === "1") || props.PlaneView === "1") {
        await grid.Rotate();
        if (generation !== documentLoadGeneration.current) return;
      }
      // grid.updateGridSize();
      grid.refreshDocumentToken = refreshDocumentToken;
      grid.sectionid = props.id;
      // const idselected = await source.getFieldText("ID");
      // setSelectedRecordID(idselected === "" ? "0" : idselected);
      setControlButtons({
        ...controlButtons,
        sign: source.findField("Doc$DSign"),
      });

      FooterDataShow(
        props.id,
        [
          `Число записей: ${source.recordCount}`,
          `Изменен ${await source.getFieldText("UpdateTime")} (${await source.getFieldText("UpdateUser")})  `,
        ],
        props.footerID,
      );
      props.setRecorcCount && props.setRecorcCount(source.recordCount);
      if (!props.noAutoFocus && MainGridRef.current) MainGridRef.current.focus();
    }
    grid.doccfgid = props.DocCfgID;
    me.current.grid = MainGridRef.current;
    if (generation !== documentLoadGeneration.current) return;
    await setActiveSite();
    if (generation !== documentLoadGeneration.current) return;
    setLoadMain(false);
    props.ObjRef && grid.refreshSource(props.ObjRef);
    return source;
  }

  function onButtonsStateChange(grid) {
    if (grid) {
      setControlButtonsState({
        ...controlButtonsState,
        card: grid.isCard(),
        filter: grid.filter.style.display === "grid",
        detail: grid.getActiveSource().details === undefined ? false : grid.getActiveSource().details.detailsBool,
      });
      setControlButtons({
        ...controlButtons,
        filter: !grid.isCard(),
        sign: grid.getActiveSource().findField("Doc$DSign"),
      });
      updStateOfButtons();
    }
  }

  async function setActiveSite() {
    let params = new Map(),
      MasterID = await MainGridRef.current.grid.source.getFieldText("ID");
    params
      .set("prefix", "documents")
      .set("comand", "SetActiveSite")
      .set("SectionID", props.id)
      .set("DocCfgID", props.DocCfgID)
      .set("PlaneView", "0");
    if (MasterID !== "") params.set("MasterID", MasterID);
    await AxiosRequest(true, params);
  }

  function testSas() {
    // if (
    //   sources.current &&
    //   sources.current[props.DocCfgID] &&
    //   sources.current[props.DocCfgID].source &&
    //   DocumentLayout &&
    //   DocumentLayout.Columns &&
    //   test
    // ) {
    //   return (
    //     <GridSas
    //       source={sources.current[props.DocCfgID].source}
    //       columns={setCollumsForGrid(DocumentLayout.Columns)}
    //     />
    //   );
    // }
  }

  function CheckDetailsSources(dcgid, DocumentLayoutDetails) {
    let detailsSource;
    if (sources.current[props.DocCfgID] && !isEmptyObject(sources.current[props.DocCfgID].sourcesDetail)) {
      for (const [key, value] of Object.entries(sources.current[props.DocCfgID].sourcesDetail)) {
        if (Number(key) === Number(dcgid)) detailsSource = value;
      }
    }
    if (detailsSource === undefined) {
      detailsSource = new createRecordSource();
      if (DocumentLayoutDetails && DocumentLayoutDetails.GridState) {
        detailsSource.setGridState(DocumentLayoutDetails.GridState);
      }
      const stateCallbackKey = `state${dcgid}${props.id}`;
      const callBack = () => {
        return beforeSaveState({ source: detailsSource, dcgid, secId: props.id });
      };
      detailsSource.onGridStateChange = () =>
        registerLeaveEffect({
          id: stateCallbackKey,
          scope: leaveScope,
          run: callBack,
        });

      sources.current = {
        ...sources.current,
        [props.DocCfgID]: {
          ...sources.current[props.DocCfgID],
          sourcesDetail: {
            ...sources.current[props.DocCfgID].sourcesDetail,
            [dcgid]: detailsSource,
          },
        },
      };
    }
    return detailsSource;
  }

  async function refreshRecord(needToUpdDetails) {
    if (MainGridRef.current && MainGridRef.current.grid) {
      await MainGridRef.current.grid.getActiveSource().refreshRecord();
      await MainGridRef.current.grid.updateGridSize();
    }
    if (needToUpdDetails) await currentDocumentHandlers.current.refreshDetails();
  }

  async function CreateDetails(gridPanel, data) {
    const isCurrent = () =>
      (data.generation === undefined || data.generation === detailsContentGeneration.current) &&
      (!data.isCurrent || data.isCurrent());
    // Поздний ответ от предыдущей выбранной записи больше не должен создавать грид
    if (!isCurrent()) return;
    let source, grid;
    if (data.ParentDocCfgID !== undefined && data.ParentDocCfgID !== "") {
      // Для детализации в детализации сначала поднимаем всю цепочку родительских гридов
      let parentDocCfgIDArr = data.ParentDocCfgID.split(","), //разделение данныех, для отрисовки грида 3001,3005; По очереди отрисовываем гриды
        parentNamesArr = data.ParentName.split(",");
      const parentIndex = data.parentIndex ?? 0;
      const gridPanelParent = me.current.querySelector(`#gridpanelDetails${data.DocCfgID}-${parentIndex}`);
      if (!gridPanelParent) return;
      let parentSource = CheckDetailsSources(parentDocCfgIDArr[0], data.DocumentLayoutDetails);
      parentSource.rights = getRightsData("-1");
      parentSource.Master = {
        parentCanModify: (flag, column) => {
          return data.ParentGrid.canModify(flag, column, data.ParentGrid, true);
        },
        isEmpty: !data.ParentGrid.source.recordCount > 0,
        source: data.ParentGrid.source,
        MasterID: data.ParentID,
        refreshRecord: refreshRecord,
      };
      //
      parentSource.onHandleRequest = onHandleRequestDocuments(parentDocCfgIDArr[0], data.ParentID);

      let columns = { title: [] },
        dest = {
          fieldInfo: { ...defaultFieldInfo },
        };
      dest.fieldName = "Doc$Title";
      dest.title = parentNamesArr[0];
      dest.width = gridPanelParent.offsetWidth - 3;
      dest.level = 0;
      columns.title.push(dest);
      const gridParent = DetailsInDetailsSize(gridPanelParent, parentDocCfgIDArr[0]);
      gridParent.refreshDocumentToken = async () => {
        await gridParent.refreshSource("!");
        await currentDocumentHandlers.current.updateButtons();
      };
      gridParent.ShowIndicatorF(false); //отключаем индикатор
      await parentSource.refresh();
      if (!isCurrent()) return;
      gridParent.setColumns(columns);
      await parentSource.open();
      if (!isCurrent()) return;
      gridParent.DisableResize = false;

      await gridParent.setSource(parentSource);
      if (!isCurrent()) return;
      parentSource.onNeedToSaveChanged = function (source) {
        onNeedToSaveChanged(gridParent, data.ParentID);
      };
      let loadingParent = true;
      let nestedGeneration = 0;
      parentSource.onRecordIndexChanged = function (source) {
        if (loadingParent || !isCurrent()) return;
        return ProcessTheDetailsInDetail(source); //при смене выбранной записи перерисовываем все послд данные
      };

      async function ProcessTheDetailsInDetail(source) {
        const generation = ++nestedGeneration;
        const parentID = await source.getFieldText("ID");
        const currentSourceDocCfgID = await source.getFieldText("DocCfgID");
        if (!isCurrent() || generation !== nestedGeneration) return;
        const ParentDocCfgID = data.ParentDocCfgID.replace(`${parentDocCfgIDArr[0]},`, "");
        const parentName = data.ParentName.replace(`${parentNamesArr[0]},`, "");

        await CreateDetails(gridPanel, {
          //вызываем сами себя с данными нужного уровня(если изменили 2 уровень, 3 и 4 поменяются)
          DocCfgID: data.DocCfgID,
          Columns: data.Columns,
          ParentID: parentID,
          ParentGrid: gridParent,
          ParentDocCfgID: ParentDocCfgID,
          CurrentSourceDocCfgID: currentSourceDocCfgID,
          gridParent: gridParent,
          ParentName: parentName,
          textField: data.textField,
          DocumentLayoutDetails: data.DocumentLayoutDetails, //115308949
          generation: data.generation,
          isCurrent: () => isCurrent() && generation === nestedGeneration,
          parentIndex: parentIndex + 1,
        });
      }
      await gridParent.refreshSource();
      if (!isCurrent()) return;
      await gridParent.updateGridSize();
      loadingParent = false;
      await ProcessTheDetailsInDetail(parentSource); //вызываем для рекурсии
    } else {
      if (data.textField) {
        SubGridRef.current = null;
        const grid = data.gridParent;
        if (grid.source.findField(data.textField + "_HTML")) {
          let textfieldcontent,
            page = true;
          textfieldcontent = await handlePage({
            DocID: data.ParentID,
            fieldName: data.textField + "_HTML",
            DocCfgID: data.CurrentSourceDocCfgID,
          });
          if (!textfieldcontent.content || isEmptyObject(textfieldcontent)) {
            textfieldcontent = grid.source.getFieldTextSync(data.textField + "_HTML");
            page = false;
            if (!textfieldcontent.content) {
              textfieldcontent = await handlePage({
                DocID: data.ParentID,
                fieldName: data.textField,
                DocCfgID: data.CurrentSourceDocCfgID,
              });
            }
          }
          if (!isCurrent()) return;
          prepareHTMLEditor(
            data.DocCfgID,
            textfieldcontent.content || textfieldcontent || "",
            data.gridParent,
            data.textField + "_HTML",
            page,
          );
        } else {
          await prepareTextField(data.DocCfgID, grid, data.textField, true, data.generation, isCurrent);
        }
        if (!isCurrent()) return;
        setLoadDetails(false);
      } else {
        const master = {
          parentCanModify: (flag, column, dd) => {
            return data.ParentGrid.canModify(flag, column, data.ParentGrid, true);
          },
          isEmpty: !data.ParentGrid.source.recordCount > 0,
          MasterID: data.ParentID,
          source: data.ParentGrid.source,
          refreshRecord: refreshRecord,
        };
        grid = gridPanel.grid;
        if (!grid) {
          source = CheckDetailsSources(data.DocCfgID, data.DocumentLayoutDetails);
          source.Master = master;
          source.onHandleRequest = onHandleRequestDocuments(data.DocCfgID, data.ParentID);
          source.onNeedToSaveChanged = function (source) {
            //изменяем массив с гридами, которые нужно сохранить
            onNeedToSaveChanged(grid);
          };
          gridPanel.grid = new createGrid(gridPanel);
          gridPanel.grid.canModify = canModify;
          grid = gridPanel.grid;
          grid.onMultiSelectChange = function (grid) {
            FooterMultiOrData(grid);
          };
          grid.BkClrField = data.DocumentLayoutDetails.BkClrField;
          grid.ColorField = data.DocumentLayoutDetails.ColorField;
          grid.StyleField = data.DocumentLayoutDetails.StyleField;
          grid.setImageFields(data.DocumentLayoutDetails.ImageFields);
          grid.CommitToSaveChanges = function (data) {
            if (props.setRedactor) {
              props.setRedactor(data);
            } else {
              if (data) document.addEventListener("click", clickAwayForRedactor, true);
              setRedactor(data);
            }
          };
          grid.doccfgid = data.DocCfgID;
          setCollumsForGrid(data.Columns, gridPanel.grid);
          await grid.setSource(source);
          if (!isCurrent()) return;
          await grid.refreshSource();
          if (!isCurrent()) return;
          grid.sectionid = props.id;
        } else {
          const title = Object.assign({}, gridPanel.grid.columns);
          if (isEmptyObject(title.title)) {
            setCollumsForGrid(data.Columns, gridPanel.grid);
          } else {
            if (!grid.isCard()) grid.setColumns(title, gridPanel.grid);
          }
          grid.getActiveSource().Master = master;
          grid.getActiveSource().onHandleRequest = onHandleRequestDocuments(data.DocCfgID, data.ParentID);
          await grid.refreshSource();
          if (!isCurrent()) return;
          // if(grid.isCard()){
          //   await grid.getActiveSource().refresh("!");
          // }
        }
        if (data.DocumentLayoutDetails.Rights) {
          grid.source.rights = getRightsData(data.DocumentLayoutDetails.Rights);
        }

        grid.getActiveSource().Master = master;
        // await grid.updateGridSize();
        gridPanel.ondragover = handleDrag;
        gridPanel.ondrop = handleDrop;
        gridPanel.onpaste = handlePaste;
        grid.refreshDocumentToken = async () => {
          await grid.refreshSource("!");
          await currentDocumentHandlers.current.updateButtons();
        };
        SubGridRef.current = gridPanel;
        if (!isCurrent()) return;
        setLoadDetails(false);
      }
    }
  }

  function onNeedToSaveChanged(grid, parentID, secId) {
    //перебираем все doccfgID и сохраняем их данные
    const dcfgid = grid.doccfgid === "0" ? props.DocCfgID : grid.doccfgid;
    if (grid.source.updatesPending === true) {
      if (props.onNeedToSaveChanged) {
        props.onNeedToSaveChanged(grid, parentID);
        return;
      }

      if (saveDocs.current[props.DocCfgID] && saveDocs.current[props.DocCfgID].dcfgid) return;
      saveDocs.current = {
        ...saveDocs.current,
        [props.DocCfgID]: {
          ...saveDocs.current[props.DocCfgID],
          [dcfgid]: {
            bool: true,
            grid: grid,
            parentID: parentID ? parentID : 0,
            id: secId,
          },
        },
      };
      setSave((currentSave) => ({ ...currentSave, [props.DocCfgID]: true }));
    } else {
      if (props.onNeedToSaveChanged) {
        props.onNeedToSaveChanged(grid, parentID);
        return;
      }
      if (saveDocs.current[props.DocCfgID] && saveDocs.current[props.DocCfgID][dcfgid]) {
        saveDocs.current = { ...saveDocs.current, [props.DocCfgID]: {} };
        setSave((currentSave) => ({ ...currentSave, [props.DocCfgID]: false }));
      }
    }
  }

  const fakePostRecord = ({ grid, index }) => {
    const recIndex = index || grid.getActiveSource().activeRecord;

    const postData = {
      Command: "PostRecord",
      RecordIndex: recIndex,
      RecordSet: { Attributes: [], Records: { Record: { $Data: [] } } },
    };
    const config = {
      prefix: Prefixes.doc,
      params: {
        DocCfgID: props.DocCfgID,
        SectionID: props.id,
        ParentID: 0,
        WSM: 1,
      },
    };
    return smetaAxios.post("HandleDocument", postData, config);
  };

  const prepareChat = async ({ grid, docCfgId, generation }) => {
    // Chat получает свежие данные записи перед рендером во вкладке
    const docId = await grid.getActiveSource().getFieldText("ID");
    const handlePageParams = {
      DocID: docId,
      DocCfgID: docCfgId,
      id: `${docCfgId}0${props.id}`,
      returnFull: true,
    };
    const jsonContent = await handlePage(handlePageParams);
    if (generation !== undefined && generation !== detailsContentGeneration.current) return;
    updateDetailModule(docCfgId, {
      type: "chat",
      key: `${docCfgId}:${docId}`,
      grid,
      docId,
      handlePageParams,
      jsonContent,
    });
  };

  async function prepareTextField(docCfgID, grid, textField, dd, generation, isCurrent) {
    // Текст сначала берем из источника и только при пустом значении идем через handlePage
    const style = {
      width: "100%",
      height: "100%",
      overflowY: "auto",
      overflowX: "hidden",
      outline: "none",
      resize: "none",
      border: "none",
    };
    let text = await grid.getActiveSource().getFieldText(textField),
      textHandlePage = {};
    if (text === "") {
      textHandlePage = await handlePage({
        fieldName: textField,
        DocID: grid.getActiveSource().getFieldTextSync("ID"),
      });
    }
    if (generation !== undefined && generation !== detailsContentGeneration.current) return;
    if (isCurrent && !isCurrent()) return;
    updateDetailModule(docCfgID, {
      type: "text",
      key: `${docCfgID}:${grid.getActiveSource().getKeyFieldNameData()}:${textField}`,
      grid,
      textField,
      dd,
      style,
      text: textHandlePage.content || text || "",
    });
  }

  const findCaption = (items, captionToFind) => {
    return items.some((item) => {
      if (captionToFind.includes(item.Caption)) return true;
      if (item.items) return findCaption(item.items, captionToFind);
      else return false;
    });
  };

  function prepareHTMLEditor(docCfgID, mimeContent, grid, textField) {
    // Готовим данные редактора, а сам компонент отрисует renderDetailModule
    const oldContainers = document.querySelectorAll(".jodit-ui-tooltip-container");
    const detailsItems = DocumentLayout?.Details?.items;
    const linkEnabled = detailsItems
      ? findCaption(Array.isArray(detailsItems) ? detailsItems : Object.values(detailsItems), [
          "Файлы",
          "Приложения",
          "Вложения",
        ])
      : false;
    if (oldContainers.length > 0) {
      for (let index = 0; index < oldContainers.length; index++) {
        const element = oldContainers[index];
        element.remove();
      }
    }
    updateDetailModule(docCfgID, {
      type: "html",
      key: `${docCfgID}:${grid.getActiveSource().getKeyFieldNameData()}:${textField}`,
      mimeContent: mimeContent.content || mimeContent,
      grid,
      textField,
      linkEnabled,
    });
  }

  function prepareDocuments(docCfgID, data) {
    // Вложенный документ тоже живет внутри текущей вкладки без отдельного createRoot
    updateDetailModule(docCfgID, {
      type: "documents",
      key: `${docCfgID}:${data.id}:${data.DocID || selectedRecordID}`,
      data,
    });
  }

  function renderDetailModule({ tab }) {
    // Тип модуля приходит из старой логики создания контента вкладки
    const moduleData = detailModules[tab.docCfgID];
    if (!moduleData) return null;

    if (moduleData.type === "chat") {
      // После отправки сообщения перечитываем грид и всю активную детализацию
      return (
        <Chat
          key={moduleData.key}
          chatData={moduleData.jsonContent}
          docId={moduleData.docId}
          handlePage={async (postData) => {
            await handlePage({ ...moduleData.handlePageParams, type: "set" }, postData);
            await fakePostRecord({ grid: moduleData.grid });
            await moduleData.grid.refreshSource("!");
            await currentDocumentHandlers.current.refreshDetails();
          }}
        />
      );
    }

    if (moduleData.type === "documents") {
      // SectionDocuments можно вкладывать как обычный React компонент
      const data = moduleData.data;
      // DocSite/DocBook может вернуть документ, который снова содержит такой же модуль.
      // Ограничиваем вложение одним уровнем, чтобы не создавать бесконечное React-дерево.
      if (me.current?.closest("[data-embedded-section-documents]")) return null;
      return (
        <div data-embedded-section-documents style={{ width: "100%", height: "100%" }}>
          <SectionDocuments
            key={moduleData.key}
            DocCfgID={data.ObjType ? data.ObjType : "-1"}
            master={{ refreshRecord }}
            canModify={(flag, column, detailGrid, dd) => data.grid.canModify(flag, column, detailGrid, dd)}
            HideParams={data.HideParams === "1"}
            SectionToolsJS={false}
            id={data.id}
            HideControlButtons
            HideDetails
            setRedactor={(value) => {
              if (value) document.addEventListener("click", clickAwayForRedactor, true);
              setRedactor(value);
            }}
            onNeedToSaveChanged={(detailGrid, parentID) => onNeedToSaveChanged(detailGrid, parentID, data.id)}
          />
        </div>
      );
    }

    if (moduleData.type === "html") {
      // HTML редактор сохраняет MIME и обычный текст в поля одной записи
      const { grid, textField } = moduleData;
      return (
        <DialogHtml
          key={moduleData.key}
          htmlInput={moduleData.mimeContent}
          HiddenButton={true}
          onSave={saveChanges}
          linksEnabled={moduleData.linkEnabled}
          readonly={!grid.canModify(1, { fieldName: textField }, { ...grid, textField: true })}
          docId={grid.getActiveSource().getKeyFieldNameData()}
          onPostRecord={async (mimeContent, textContent) => {
            // Одинаковое значение не отправляем повторно на сервер
            if (grid.getActiveSource().getFieldTextSync(textField) !== mimeContent) {
              await grid.postSomeData(textField, { text: mimeContent });
              await grid.postSomeData(textField.replace("_HTML", ""), { text: textContent });
              await grid.postExicstedEditRec(false);
              await currentDocumentHandlers.current.refreshDetails();
            }
          }}
          onChange={(mimeContent, textContent, resetToServerValue) => {
            // Пока редактор изменен, наружу отдаем действия применить и отменить
            if (grid.source.getFieldTextSync(textField) !== mimeContent) {
              const recIndex = grid.getActiveSource().activeRecord;
              setRedactor({
                postExicstedEditRec: async () => {
                  await grid.postSomeData(textField, { text: mimeContent }, recIndex);
                  await grid.postSomeData(textField.replace("_HTML", ""), { text: textContent }, recIndex);
                  await grid.postExicstedEditRec(false);
                  await currentDocumentHandlers.current.refreshDetails();
                },
                cancelRecord: () => {
                  resetToServerValue();
                  setRedactor(false);
                },
              });
              document.addEventListener("click", clickAwayForRedactor, true);
            }
          }}
        />
      );
    }

    if (moduleData.type === "text") {
      // Обычный текст сохраняем через тот же механизм подтверждения изменений
      const { grid, textField } = moduleData;
      return (
        <IMemo
          key={moduleData.key}
          readOnly={!grid.canModify(1, { fieldName: textField }, { ...grid, textField: true }, moduleData.dd)}
          style={moduleData.style}
          Text={moduleData.text}
          onChange={(event) => {
            const value = event.target.value;
            const recIndex = grid.getActiveSource().activeRecord;
            setRedactor({
              postExicstedEditRec: async () => {
                await grid.postSomeData(textField, { text: value }, recIndex);
                await grid.postExicstedEditRec(false);
              },
              cancelRecord: () => setRedactor(false),
            });
          }}
          onBlur={(event) => {
            if (redactorRef.current && !(event.relatedTarget && event.relatedTarget.closest(".CloseButtonForGrid"))) {
              redactorRef.current.postExicstedEditRec(false);
              props.setRedactor ? props.setRedactor(false) : setRedactor(false);
            }
          }}
        />
      );
    }

    return null;
  }
  // function WorkWithSource(source, grid) {}

  function DetailsInDetailsSize(gridPanelParent, parentDocCfgID) {
    if (!gridPanelParent.grid) gridPanelParent.grid = new createGrid(gridPanelParent);
    gridPanelParent.grid.doccfgId = parentDocCfgID;
    gridPanelParent.grid.detailsInDetail = true;
    // gridPanelParent.grid.canModify = (flag) => {
    //   return false;
    // };
    gridPanelParent.grid.sectionid = props.id;
    gridPanelParent.grid.canModify = canModify;
    return gridPanelParent.grid;
  }
  function deepEqual(obj1, obj2) {
    if (obj1 === obj2) return true;
    if (typeof obj1 !== "object" || obj1 === null || typeof obj2 !== "object" || obj2 === null) return false;

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;

    return keys1.every((key) => deepEqual(obj1[key], obj2[key]));
  }

  function onHandleRequestDocuments(DocCfgID, ParentID, id, wsm) {
    //общой handleRequest
    return async function (request, load = true, wsmFromGrid) {
      const generation = documentLoadGeneration.current;
      let params = new Map();
      params.set("prefix", "documents");
      params.set("comand", "HandleDocument");
      params.set("DocCfgID", DocCfgID);
      params.set("SectionID", id ? id : props.id);
      params.set("ParentID", ParentID === undefined ? parentID : ParentID);
      if (wsm || wsmFromGrid) params.set("WSM", "1");
      const result = await AxiosRequest(load, params, request);
      if (generation !== documentLoadGeneration.current) return result;
      if (result.Tabs) {
        // Сервер может скрыть вкладки после выполнения команды внутри документа
        const newHiddenTabsData = Object.entries(result.Tabs).reduce(
          (acc, [key, value]) => ({ ...acc, [key]: value.Hidden === "1" }),
          {},
        );
        if (deepEqual(hiddenTabsRef.current, newHiddenTabsData)) return result;
        hiddenTabsRef.current = newHiddenTabsData;
        setHiddenTabs(newHiddenTabsData);
        // После скрытия вкладки выбираем ближайшую оставшуюся
        const visibleTabs = flattenDocumentDetails(currentDocumentHandlers.current.layout?.Details, newHiddenTabsData);
        const nextIndex = Math.max(0, Math.min(currentDocumentHandlers.current.tabIndex, visibleTabs.length - 1));
        detailsLayoutGeneration.current++;
        detailsContentGeneration.current++;
        detailsRequest.current = undefined;
        documentLayoutDetailsRef.current = undefined;
        if (visibleTabs[nextIndex]) {
          setTimeout(() => {
            if (generation === documentLoadGeneration.current) {
              currentDocumentHandlers.current.onTabChange(nextIndex, visibleTabs[nextIndex]);
            }
          }, 0);
        } else {
          setLoadDetails(false);
        }
      }
      return result;
    };
  }

  // Получение данных о документе, основываясь на его DocCfgID
  function GetDocumentLayout(docConfigID, MasterID, refresh) {
    let params = new Map();
    if (!docConfigID) return;
    params.set("prefix", "documents");
    params.set("comand", "GetDocumentLayout");
    params.set("DocCfgID", docConfigID);
    params.set("SectionID", props.id);
    if (MasterID !== undefined) params.set("MasterID", MasterID);
    params.set("GridState", 1);
    if (refresh) {
      params.set("ClearState", 1);
      params.set("Refresh", 1);
    }
    return AxiosRequest(true, params);
    // return XMLrequest(params);
  }

  // Параметры
  function ReturnParams(data) {
    if (data) {
      return (
        <Params
          Module={"documents"}
          id={props.DocCfgID}
          SectionID={props.id}
          data={data.Params}
          Path={data.Params.Path}
          NoTitle={true}
          defaultFilter={data.Filter === "1" ? true : false}
          fixHistory={fixHistory}
          setFixHistory={setFixHistory}
        />
      );
    } else {
      return <LoadingMask />;
    }
  }

  function getDocumentTreeProps() {
    return {
      ...props.tree,
      Module: props.tree?.Module ?? "documents",
      ObjType: props.tree?.ObjType ?? props.DocCfgID,
      SectionID: props.tree?.SectionID ?? props.SectionID ?? props.id,
      selectID: setParentID,
    };
  }

  function getTree(docLay) {
    if (docLay.HasTree === "1") {
      return <Tree props={getDocumentTreeProps()} />;
    }
  }

  // Обработка изменения параметров и перерисовка грида на основе измененных параметров
  async function ApplyButtonClick() {
    if (redactor) {
      await redactor.postExicstedEditRec();
    }
    await refreshFullDocument();
    if (paramPath && !props.HideParams) {
      const json = await FixParamHistory(paramPath);
      if (json.History) setFixHistory(json.History);
    }
  }

  async function refreshFullDocument(refresh) {
    let selectRecord = await MainGridRef.current.grid.getActiveSource().getFieldText("ID");
    if (selectRecord === "" || refresh) {
      await MainGridRef.current.grid.refreshSource();
    } else {
      await MainGridRef.current.grid.refreshSource("!" + selectRecord);
    }
    if (!detailsBool) {
      await currentDocumentHandlers.current.refreshDetails();
    }
    await updStateOfButtons();
  }

  function FixParamHistory(path) {
    // programs~FixParamHistory?LicGUID=3BF73F2A46DEF36C917A8C964E996C79&Path=Documents\Params\3008\108
    const params = new Map();
    params.set("prefix", "programs").set("comand", "FixParamHistory").set("Path", path);
    return AxiosRequest(true, params);
  }
  // Костыльная функция для отрисовки деталий основного грида
  function ChangeCollapsedDetails(bool) {
    setDetailsBool(bool);
    sources.current = {
      ...sources.current,
      [props.DocCfgID]: { ...sources.current[props.DocCfgID], details: bool },
    };
    if (smetaStore.get(animationsAtom)) {
      clearTimeout(timeoutUpdateGrid.current);
      timeoutUpdateGrid.current = setTimeout(() => {
        TestUpdateGrid().then(() => {
          currentDocumentHandlers.current.refreshDetails();
        });
      }, 501);
    } else {
      clearTimeout(timeoutUpdateGrid.current);
      timeoutUpdateGrid.current = setTimeout(() => {
        TestUpdateGrid().then(() => {
          currentDocumentHandlers.current.refreshDetails();
        });
      }, 1);
    }
  }

  // Перерасчет размеров грида
  async function TestUpdateGrid() {
    if (MainGridRef.current.grid) {
      await updateVisibleGrids();
      await MainGridRef.current.grid.scrollTo(MainGridRef.current.grid.getActiveSource().activeRecord);
    }
    if (!detailsBool) {
      // await SubGridRef.current.grid.updateGridSize();
      let tab = getActiveDetailContent();
      if (tab) {
        tab = tab.querySelectorAll(".grid-panel");
        if (tab.length > 0) {
          for (let DetailGrid of tab) {
            if (DetailGrid.grid) {
              await DetailGrid.grid.updateGridSize();
            }
          }
        }
      }
    }
  }

  function CreateRecordCopy(DocCfgID, DocId) {
    let params = new Map();
    params.set("prefix", "documents");
    params.set("comand", "CreateRecordCopy");
    params.set("SectionID", props.id);
    params.set("DocCfgID", DocCfgID);
    params.set("ID", DocId);
    return AxiosRequest(true, params);
  }

  // Изменить вид грида(фильтр и группировка)
  // function UpdateGridFunctional(index) {
  //   MainGridRef.current.grid.setOptions(index);
  // }

  // При смене вкладки загружаем ее настройки и игнорируем ответ от предыдущей
  async function onTabChange(newTabIndex, detailTab) {
    const masterID = MainGridRef.current?.grid?.getActiveSource()?.getFieldTextSync("ID") ?? "";
    const pending = detailsRequest.current;
    if (pending?.docCfgID === detailTab.docCfgID && pending.masterID === masterID) return pending.promise;
    const generation = ++detailsLayoutGeneration.current;
    // Сразу прекращаем отрисовку прежней вкладки, не дожидаясь ответа layout.
    detailsContentGeneration.current++;
    documentLayoutDetailsRef.current = undefined;
    detailsContext.current = undefined;
    currentDocumentHandlers.current.tabIndex = newTabIndex;
    setLoadDetails(true);
    setSelectedTabIndex(newTabIndex);
    const loadLayout = async () => {
      try {
        const res = await GetDocumentLayout(detailTab.docCfgID, masterID);
        if (generation !== detailsLayoutGeneration.current) return;
        if (res?.GridState) res.GridState = parseGridState(res.GridState);
        if (!isEmptyObject(res?.Tools)) res.Tools = parseShortsCuts(res.Tools, detailTab.docCfgID);
        detailsContext.current = { docCfgID: detailTab.docCfgID, masterID };
        documentLayoutDetailsRef.current = res;
        setDocumentLayoutDetails(res);
      } finally {
        if (generation === detailsLayoutGeneration.current) {
          detailsRequest.current = undefined;
          setLoadDetails(false);
        }
      }
    };
    const promise = loadLayout();
    detailsRequest.current = { docCfgID: detailTab.docCfgID, masterID, promise };
    return promise;
  }
  // Изменение размеров
  function onResizeEnd() {
    clearTimeout(timeoutUpdateGrid.current);
    timeoutUpdateGrid.current = setTimeout(() => {
      TestUpdateGrid();
    }, 1);
  }

  function onCollapse() {
    if (DocumentLayout !== undefined && DocumentLayout.HasTree === "1" && DocumentLayout.ForceUpdates === "1") {
      parentIDStorage.current.needUpdt = false;
      refreshMainGrid({ DocCfgID: props.DocCfgID, ParentID: "0" });
    }
    onResizeEnd();
  }

  function onExpand() {
    if (DocumentLayout !== undefined && DocumentLayout.HasTree === "1" && DocumentLayout.ForceUpdates === "1") {
      parentIDStorage.current.needUpdt = true;
      refreshMainGrid({
        DocCfgID: props.DocCfgID,
        ParentID: parentIDStorage.current.id,
      });
    }
    onResizeEnd();
  }

  function onFocusChange(e) {
    if (e.currentTarget.grid && focusedGridRef.current !== e.currentTarget) {
      //
      // setFocusedGrid()
      focusedGridRef.current = e.currentTarget;
      FooterMultiOrData(e.currentTarget.grid);
    }
  }

  function detailsInDetailsSizeChange(block, detailTab) {
    // Складываем ширину родительских панелей и сохраняем ее для следующего рендера
    const grids = block.querySelectorAll(".grid-panel");
    const splitterItems = Array.from(block.firstElementChild?.children ?? []).filter((item) =>
      item.hasAttribute("data-splitteritemindex"),
    );
    const splitterSize = splitterItems
      .slice(0, detailTab.parents.length)
      .reduce((size, item) => size + item.offsetWidth, 0);
    if (detailTab.parents.length && splitterSize !== 112) {
      const maingridDetails = MainGridRef.current.grid.getActiveSource().details;
      MainGridRef.current.grid.getActiveSource().details = {
        ...maingridDetails,
        DetailsSplittersSizes: {
          ...maingridDetails.DetailsSplittersSizes,
          [detailTab.docCfgID]: splitterSize,
        },
      };
      setDetailsSplittersSizes((current) => ({ ...current, [detailTab.docCfgID]: splitterSize }));
    }
    for (const detailsGrid of Object.values(grids)) {
      if (detailsGrid && detailsGrid.grid) {
        if (detailsGrid.grid.detailsInDetail) {
          detailsGrid.grid.header.firstChild.field.width = detailsGrid.offsetWidth - 2;
        }
        detailsGrid.grid.updateGridSize();
      }
    }
  }

  // Собираем содержимое активной вкладки по ее типу
  async function UpdDetails(tabIndex, DocumentLayoutDetails) {
    const activeTab = getActiveDetailTab();
    if (
      !activeTab ||
      detailsContext.current?.docCfgID !== activeTab.docCfgID ||
      detailsContext.current.masterID !== MainGridRef.current?.grid?.getActiveSource()?.getFieldTextSync("ID") ||
      DocumentLayoutDetails !== documentLayoutDetailsRef.current
    )
      return;
    tabIndex = currentDocumentHandlers.current.tabIndex;
    if (
      DocumentLayout !== undefined &&
      !isEmptyObject(DocumentLayout.Details) &&
      !isEmptyObject(DocumentLayoutDetails)
    ) {
      const generation = ++detailsContentGeneration.current;
      setLoadDetails(true);
      try {
        const detailTab = getActiveDetailTab(tabIndex);
        if (!detailTab) return;
        const DetailsDocCfgID = detailTab.docCfgID;
        const ParentDocCfgID = detailTab.parents.map((parent) => parent.docCfgID).join(",");
        const ParentName = detailTab.parents.map((parent) => parent.name).join(",");
        const GridDetailsBlock = me.current.querySelector("#gridpanel" + DetailsDocCfgID);
        const textField = detailTab.textField;
        updAllShortsCut(DocumentLayoutDetails, DetailsDocCfgID);
        if (textField !== null && detailTab.parents.length === 0) {
          // Простая детализация без родителей может быть модулем вместо грида
          SubGridRef.current = null;
          const mainGrid = MainGridRef.current.grid;
          const docID = await mainGrid.getActiveSource().getFieldText("ID");
          if (generation !== detailsContentGeneration.current) return;

          if (textField === ViewClass.Chat) {
            await prepareChat({ grid: mainGrid, docCfgId: DetailsDocCfgID, generation });
          } else if ([ViewClass.DocSite, ViewClass.DocBook].includes(textField)) {
            const idForDocument = Number(props.id) + Number(DetailsDocCfgID) * 10000;
            const infoAboutDoc = await handlePage({ DocID: docID, DocCfgID: DetailsDocCfgID, id: idForDocument });
            if (generation !== detailsContentGeneration.current) return;
            prepareDocuments(DetailsDocCfgID, {
              ...infoAboutDoc,
              DocID: docID,
              id: idForDocument,
              grid: mainGrid,
            });
          } else if (mainGrid.getActiveSource().findField(textField + "_HTML")) {
            let textfieldcontent = await handlePage({ DocID: docID, fieldName: textField + "_HTML" });
            if (!textfieldcontent.content || isEmptyObject(textfieldcontent)) {
              textfieldcontent = mainGrid.getActiveSource().getFieldTextSync(textField);
              if (!textfieldcontent?.content) {
                textfieldcontent = await handlePage({ DocID: docID, fieldName: textField });
              }
            }
            if (generation !== detailsContentGeneration.current) return;
            prepareHTMLEditor(
              DetailsDocCfgID,
              textfieldcontent?.content || textfieldcontent || "",
              mainGrid,
              textField + "_HTML",
            );
          } else {
            await prepareTextField(DetailsDocCfgID, mainGrid, textField, undefined, generation);
          }
          if (generation === detailsContentGeneration.current) setLoadDetails(false);
          return;
        }

        if (!GridDetailsBlock) return;
        // Для обычной и вложенной детализации создаем legacy-гриды в готовых панелях
        await CreateDetails(GridDetailsBlock, {
          DocCfgID: DetailsDocCfgID,
          Columns: DocumentLayoutDetails.Columns,
          ParentDocCfgID: ParentDocCfgID ? ParentDocCfgID + "," : "",
          ParentID: await MainGridRef.current.grid.getActiveSource().getFieldText("ID"),
          ParentGrid: MainGridRef.current.grid,
          ParentName: ParentName ? ParentName + "," : "",
          DocumentLayoutDetails: DocumentLayoutDetails,
          textField: textField,
          length: detailTab.parents.length,
          generation,
        });
      } finally {
        if (generation === detailsContentGeneration.current) setLoadDetails(false);
      }
    }
  }

  const printReport = () => {
    const reportTabs = document.getElementById(`ReportsTabs${props.DocCfgID}`);
    const frame = reportTabs.getSelectedContent().firstChild;
    if (frame.contentWindow) {
      frame.contentWindow.print();
    }
  };

  async function ControlButtonClick(e) {
    const value = e.currentTarget.getAttribute("value");
    switch (value) {
      case "RefreshFull":
        await ApplyButtonClick();
        break;
      case "print": {
        printReport();
        break;
      }
      case "append":
        if (samples.length === 0) {
          MainGridRef.current.grid.appendRecord();
        } else {
          handleClickAnchorEl(e);
        }
        break;
      case "details":
        //
        ChangeCollapsedDetails(!detailsBool);
        // ChangeCollapsedDetailsByButton();
        break;
      case "sign":
        const params = DocumentRequest({ command: "GetDocSignImage", details: true, wsm: true });
        AxiosRequest(true, params).then(async (response) => {
          let data = response;
          if (response.Token !== "SignDialog" && response.Result === "1" && response.RCDATA) {
            // alert("неверный формат открытия");
            const Notes = await MainGridRef.current.grid.getActiveSource().getRecordInfo();
            const utf8decoder = new TextDecoder("windows-1251");
            const arcdata = atob(response.RCDATA);
            const uint8 = Uint8Array.from(arcdata.split("").map((x) => x.charCodeAt()));
            const content = utf8decoder.decode(uint8);
            const ObjRef = MainGridRef.current.grid.getActiveSource().getFieldTextSync("ID");
            data = {
              Token: "SignDialog",
              Break: "1",
              content: content,
              Params: {
                RCDATA: response.RCDATA,
                ObjType: props.DocCfgID,
                ObjRef: ObjRef,
                Token: "0",
                ID: ObjRef,
                Notes: Notes.title,
                Options: "1026",
              },
            };
          }
          tokenProcessingTest(data, {
            func: () => {
              refreshRecord();
            },
            from: "grid",
          });
        });
        break;
      case "Commit":
        CommitSaveOrCancelChanges(e.currentTarget.getAttribute("command"));
        break;
      case "SaveRedactor":
        await redactor.postExicstedEditRec();
        if (props.setRedactor) {
          props.setRedactor(false);
        } else {
          setRedactor(false);
        }

        break;
      case "CancelRedactor":
        await redactor.cancelRecord();
        if (props.setRedactor) {
          props.setRedactor(false);
        } else {
          setRedactor(false);
        }
        await currentDocumentHandlers.current.refreshDetails();
        break;
      case "cardmode": {
        await MainGridRef.current.grid.Rotate();
        break;
      }
      default:
        break;
    }
  }

  function sampleMenuClick(e) {
    const textContent = e.currentTarget.textContent;
    setAnchorEl(null);
    if (textContent === "Новый документ") {
      MainGridRef.current.grid.appendRecord();
    } else {
      handleSamples("document", { Name: textContent }).then((res) => {
        if (res.Result) {
          AfterWSM(MainGridRef.current, { DocID: res.Result });
        }
      });
    }
  }

  async function handleSamples(command, sampleInfo) {
    let params = new Map();
    params.set("prefix", "documents");
    params.set("comand", "HandleSamples");
    params.set("Command", command);
    params.set("SectionID", props.id);
    params.set("DocCfgID", props.DocCfgID);
    switch (command) {
      case "create": {
        params.set("Name", sampleInfo.Name);
        params.set("DocID", selectedRecordID);
        params.set("AllUsers", sampleInfo.AllUsers);
        params.set("All", sampleInfo.All);
        break;
      }
      case "delete": {
        params.set("Name", sampleInfo.Name);
        params.set("User", sampleInfo.User);
        params.set("Section", sampleInfo.Section);
        break;
      }
      case "document": {
        params.set("Name", sampleInfo.Name);
        break;
      }
    }
    const json = await AxiosRequest(true, params);
    if (json.items) {
      setSamples(json.items);
    }
    return json;
  }

  async function CommitSaveOrCancelChanges(command) {
    let commandToDo = command === undefined ? "CommitUpdates" : command;
    //
    const id = await MainGridRef.current.grid.source.getFieldText("ID");
    await processCommitOrCancelUpdates({
      commandToDo: commandToDo,
      dcfgid: props.DocCfgID,
      parentID: 0,
      id: props.id,
    });
    await MainGridRef.current.grid.refreshSource("!");
    for (const value of getDetailTabs()) {
      await processCommitOrCancelUpdates({
        dcfgid: value.docCfgID,
        commandToDo: commandToDo,
        parentID: id,
        id: props.id,
      });
      if ([ViewClass.DocSite, ViewClass.DocBook].includes(value.textField)) {
        const idForDocument = Number(props.id) + Number(value.docCfgID) * 10000;
        const TextFieldBlockDocuments = document.getElementById("Documents" + idForDocument);
        if (TextFieldBlockDocuments) {
          await TextFieldBlockDocuments.CommitSaveOrCancelChanges(commandToDo);
        }
      }
    }

    async function processCommitOrCancelUpdates(
      data = { dcfgid: props.DocCfgID, parentID: 0, id: props.id, commandToDo },
    ) {
      const request = onHandleRequestDocuments(data.dcfgid, data.parentID ? data.parentID : "0", data.id, true);
      const otvet = await request({
        Command: data.commandToDo,
      });
      if (otvet.Token) {
        await new Promise((resolve) => {
          tokenProcessingTest(otvet, { func: resolve, from: "grid" });
        });
      }
    }

    const afterSave = async () => {
      if (MainGridRef.current.grid?.isCard()) {
        await MainGridRef.current.grid.updateCard();
      }
      await currentDocumentHandlers.current.refreshDetails();
      await currentDocumentHandlers.current.updateButtons();
    };

    await afterSave();

    if (MainGridRef.current.grid) MainGridRef.current.grid.changeIndicator(1);
  }

  async function selectViewOfPaperForm(event) {
    if (selectedView === "paper") {
      setSelectedView("doc");
      setSelectedViewIdent("");
      setControlButtons({ ...controlButtons, print: false, save: true });
      formidRef.current = null;
    } else {
      let forms = DocumentLayout.Forms || [];
      if (DocumentLayout.Handle === "1") {
        const params = DocumentRequest({ command: "GetMenuState", type: "forms" });
        const menuState = await AxiosRequest(true, params);
        const hiddenItemsInfo = menuState[0]?.Hidden?.split(",") || [];
        forms = forms.filter(({ ID: id }) => !hiddenItemsInfo.includes(id));
        setFormsList(forms);
        if (forms.length === 0) return;
        if (forms.length === 1) formidRef.current = forms[0].ID;
      }
      if (forms.length > 1) {
        handleClickAnchorEl(event);
      } else PaperForm(event);
    }
  }

  // Получение печатной формы документа
  function PaperForm(event) {
    let params = DocumentRequest({ command: "GetDocumentForm", details: true, wsm: true });
    let formidlocal;
    if (formidRef.current !== null) formidlocal = formidRef.current;
    else if (event && event.currentTarget) {
      formidlocal = event.currentTarget.getAttribute("formid");
      formidRef.current = formidlocal;
    }
    params.set("ID", formidlocal);
    if (MainGridRef.current.grid.getMultiSelect().length > 0) {
      CheckMultiSelect(MainGridRef.current.grid).then((selection) => {
        params.set("Selection", selection);
        AfterSelection();
      });
    } else {
      AfterSelection();
    }
    function AfterSelection() {
      setAnchorEl(null);
      AxiosRequest(true, params).then((resp) => {
        tokenProcessingTest(resp, { func: openForms });
      });
    }
  }

  function openForms(form) {
    let reportViewIdent = "";
    const commonViewIdent = form.ViewIdent;
    const selectedReportTabIndex = form.TabIndex;
    if (selectedReportTabIndex) {
      const selectedReportTab = form.Items.filter((tab, index) => index === selectedReportTabIndex);
      reportViewIdent = selectedReportTab[0].ViewIdent;
    }
    setSelectedViewIdent(`${commonViewIdent}.${reportViewIdent}`);
    setSelectedView("paper");
    setControlButtons({ ...controlButtons, print: true, save: false });
    setPaperFormData(form);
  }

  const handleClickAnchorEl = (event) => {
    //
    setAnchorEl(event.target instanceof HTMLButtonElement ? event.target : event.currentTarget);
  };

  const handleCloseAnchorEl = () => {
    setAnchorEl(null);
    setAnchorElButton(null);
  };

  // Функция для обработки кликов в контекстном меню
  async function ContextMenuHandler(data, gridRef) {
    const comand = data.value;
    const grid = gridRef.current ? gridRef.current : gridRef;
    switch (comand) {
      case "clearAllFilters": {
        grid.grid.clearAllFilters();
        break;
      }
      case "ClearDocumentState":
        setDocumentLayout(undefined);
        grid.grid.setFilterData({});
        ClearDocumentStatus("refresh");
        // ApplyButtonClick();
        break;
      case "OnlyViewMode": {
        grid.grid.ChangeViewMode();
        await updStateOfButtons();
        break;
      }
      case "RecordCopy":
        CreateRecordCopy(await grid.grid.source.getFieldText("DocCfgID"), await CheckMultiSelect(grid.grid)).then(
          async (res) => {
            await grid.grid.refreshSource(res.ID);
            await currentDocumentHandlers.current.refreshDetails();
          },
        );
        break;
      case "SaveRedactor":
        await redactor.postExicstedEditRec();
        if (props.setRedactor) {
          props.setRedactor(false);
        } else {
          setRedactor(false);
        }
        break;
      case "CancelRedactor":
        await redactor.cancelRecord();
        if (props.setRedactor) {
          props.setRedactor(false);
        } else {
          setRedactor(false);
        }
        currentDocumentHandlers.current.refreshDetails();
        break;
      case "Settings": {
        // CreateBackgroundForModal();
        smetaModals.open(<DocInfoAndSettings grid={grid.grid} />, {
          Title: "Документ",
          style: { height: `${430}px`, width: `${580}px` },
          hiddenButton: true,
          blockMaximize: true,
          onClose: () => {
            setLastFocus();
          },
        });
        break;
      }
      case "Details": {
        ChangeCollapsedDetails(!detailsBool);
        break;
      }
      case "Samples": {
        handleSamples("list").then((res) => {
          smetaModals.open(<Samples request={handleSamples} list={res === undefined ? [] : res} />, {
            Title: "Новый шаблон",
            style: { height: `${430}px`, width: `${580}px` },
            hiddenButton: true,
            blockMaximize: true,
            blockResize: true,
            onClose: () => {
              setLastFocus();
            },
          });
        });
        break;
      }
      case "Numbering": {
        SequenceGetParams({
          Name: DocumentLayout.Sequence,
          GetNumMode: "1",
        }).then((res) => {
          smetaModals.open(
            <DialogDocNumbering
              props={{
                Sequence: DocumentLayout.Sequence,
                Name: DocumentLayout.Name,
                res: res,
              }}
            />,
            {
              Title: "Нумерация",
              style: getStyleWindow("sequence"),
              onClose: () => {
                setLastFocus();
              },
            },
          );
        });
        break;
      }
      case "CopyDocLink": {
        let link = window.location.href;
        link += `&modal&parsed&docid=${selectedRecordID}&doccfgid=${props.DocCfgID}&card`;
        let lastloginDrx = localStorage.getItem("LastLogin");
        if (lastloginDrx) {
          lastloginDrx = lastloginDrx.split(",");
          if (lastloginDrx.length > 0) {
            link += `configname=${lastloginDrx[0]}`;
          }
        }
        try {
          navigator.clipboard.writeText(link);
        } catch {
          alert(link);
        }
        break;
      }
      case "PrintSelectedRecords": {
        CheckMultiSelect(grid.grid).then((selection) => {
          let params = new Map(),
            data = {},
            sourceFields = grid.grid.getActiveSource().fields;
          params
            .set("prefix", "documents")
            .set("comand", "HandleToolButton")
            .set("ID", "-17")
            .set("DocCfgID", grid.grid.doccfgid)
            .set("WSM", "1");
          // data = getShowedCols(grid.grid.columns.levels);
          const cols = getShowedCols(grid.grid.columns.levels, sourceFields);
          for (const [key, value] of Object.entries(cols)) {
            data[`field${Number(key) + 1}`] = value;
          }
          AxiosRequest(true, params, {
            ...data,
            $content: selection,
          }).then((res) => {
            tokenProcessingTest(res);
          });
        });
        break;
      }
      default:
        if (data.ID) HandleToolButton({ currentTarget: { id: data.ID, doccfgid: data.doccfgid } }, grid);
        if (data.Status) changeStatus(data.Status);
        break;
    }
  }

  function getShowedCols(data, sourceFields) {
    return data.reduce((result, item, index) => {
      const field = item.field;
      if (field.hide === true) {
        return result;
      }
      if (item.expanded && item.items) {
        const nestedResult = getShowedCols(item.items, sourceFields, index);
        return result.concat(nestedResult);
      }
      const sourceField = getFieldFromData(sourceFields, field.fieldName)[0];
      result.push({ Заголовок: field.title, Ширина: field.width, ИмяПоля: sourceField.displayLabel });
      return result;
    }, []);
  }
  function getFieldFromData(data, fieldName) {
    return data.filter((val) => {
      if (val.fieldName === fieldName) {
        return val;
      }
    });
  }

  function DocumentRequest({
    command,
    details,
    type,
    wsm = false,
    docCfgID = props.DocCfgID,
    grid = MainGridRef.current.grid,
  }) {
    let params = new Map();
    const masterGrid = MainGridRef.current.grid;
    params.set("prefix", "documents");
    params.set("comand", command);
    params.set("SectionID", props.id);
    params.set("DocCfgID", docCfgID);
    params.set("MasterID", masterGrid.getActiveSource().getFieldTextSync("ID"));
    params.set("MasFld", masterGrid.getSelectedField()); // выбранная колонка в мастер гриде
    params.set("PlaneView", masterGrid.isCard() ? 1 : 0); //режим карточки
    params.set("DocID", grid.getActiveSource().getFieldTextSync("ID"));
    if (!detailsBool && details) {
      //активны ли детали
      params.set("ActiveDetail", getActiveDetailTab()?.docCfgID); // DocCfgID активной детализации
      if (SubGridRef.current !== null) {
        params.set("DetailID", SubGridRef.current.grid.getActiveSource().getFieldTextSync("ID"));
        params.set("DetFld", SubGridRef.current.grid.getSelectedField());
      }
    }
    if (type) params.set("type", type);
    if (wsm) params.set("WSM", "1");
    return params;
  }

  const handlePage = async (data, postData) => {
    let params = new Map();
    params.set("prefix", "documents");
    params.set("comand", "HandlePage");
    params.set("Type", data.type || "get");
    params.set("DocID", data.DocID);
    if (data.fieldName) params.set("fieldName", data.fieldName);
    params.set("DocCfgID", data.DocCfgID || props.DocCfgID);
    params.set("SectionID", data.id || props.id);
    // params.set("WSM", "1");
    let resp = await AxiosRequest(true, params, postData);
    return !isEmptyObject(resp) ? resp : "";
    AxiosRequest(true, params).then((res) => {
      tokenProcessingTest(res, { func: HandleStatusChange });
    });
  };

  function GetMenu(commands, layout) {
    // GetMenuStatus().then((statuses) => {
    //   GetMenuState().then((state) => {
    //     return DocumentLayout.Tools.Menu;
    //   });
    // });
    const dataForMenu = {
      docCfgID: layout.grid.doccfgid,
      grid: layout.grid,
    };
    let status,
      obj,
      state,
      finalArr = [];
    status = commands.status ? GetMenuSt({ command: "GetStatusList", ...dataForMenu }) : [];
    state = commands.state ? GetMenuSt({ command: "GetMenuState", ...dataForMenu }) : [];

    // if (status.length > 0)
    if (layout.Tools && layout.Tools.Menu)
      // finalArr.push({ Caption: "Статус документа", items: { ...status } });
      // if (state.length > 0) finalArr.push(state);
      finalArr = [...finalArr, ...layout.Tools.Menu];
    obj = {
      arr: finalArr,
      state: state,
      status: { Caption: "Статус документа", items: { ...status } },
    };
    if (!commands.status) {
      delete obj.status;
    }
    return obj;
  }

  // function GetMenuState() {
  //   const params = DocumentRequest("GetMenuState");
  //   // AxiosRequest(true, params).then((resp) => {
  //   //   return resp;
  //   // });
  //   return XMLrequest(params);
  // }
  function GetMenuSt(data) {
    const params = DocumentRequest(data);
    // AxiosRequest(true, params).then((resp) => {
    //   return resp;
    // });
    return XMLrequest(params);
  }

  async function changeStatus(status) {
    let params = new Map();
    params.set("prefix", "documents");
    params.set("comand", "ChangeStatus");
    params.set("Status", status);
    if (MainGridRef.current.grid.getMultiSelect().length > 0) {
      const selection = await CheckMultiSelect(MainGridRef.current.grid);
      params.set("DocID", selection);
    } else {
      params.set("DocID", MainGridRef.current.grid.getActiveSource().getFieldTextSync("ID"));
    }
    params.set("DocCfgID", props.DocCfgID);
    params.set("SectionID", props.id);
    params.set("WSM", "1");
    if (MainGridRef.current.grid.getActiveSource().isEditMode()) {
      await MainGridRef.current.grid.postExicstedEditRec(); // todo
    }
    const statusResp = await AxiosRequest(true, params);
    tokenProcessingTest(statusResp, {
      func: HandleStatusChange,
      from: "grid",
    });
    // AxiosRequest(true, params).then((res) => {
    //   tokenProcessingTest(res, { func: HandleStatusChange });
    // });
  }

  async function HandleStatusChange(json) {
    if (json.Result === "1") {
      MainGridRef.current.grid.refreshSource("!");
      if (
        (MainGridRef.current &&
          MainGridRef.current.grid &&
          MainGridRef.current.grid.source.details &&
          MainGridRef.current.grid.source.details.detailsBool === false) ||
        !detailsBool
      ) {
        await currentDocumentHandlers.current.refreshDetails();
      }
    }
    await MainGridRef.current.grid.getActiveSource().getFieldText("ID");
    setCanModifyObj({
      delete: !(await MainGridRef.current.grid.canModify(2, undefined, MainGridRef.current.grid)),
      insert: !(await MainGridRef.current.grid.canModify(0, undefined, MainGridRef.current.grid)),
    });
  }

  const showParams = (data) => {
    if (data) {
      if (data.Params === undefined || data.Params.Items === undefined) {
        return false;
      }
      if (data.Params.Items.length === 0) {
        return false;
      }
      if (data.Params.Items.length === 1 && data.Params.Items[0].JSONType !== undefined) {
        return false;
      }
      if (data.HasTree === "1") return false;
    }
    return true;
  };

  const handlePaste = async function (e) {
    const gridPanel = e.target.closest(".grid-panel");
    if (!gridPanel.grid) return;
    const grid = gridPanel.grid;
    e.stopPropagation();
    if (grid.editorMode()) return;

    const items = (e.clipboardData || window.clipboardData).items;
    const files = [];

    for (const item of items) {
      if (item.kind === "file") {
        const file = item.getAsFile();
        files.push(file);
      }
    }
    if (files.length === 0) return;
    e.preventDefault();
    e.stopPropagation();

    if (files.length > 0) {
      const filesNames = files.map((file) => file.name);
      const filesData = await Promise.all(files.map((file) => getBase64ByFileReader(file)));
      const finalData = filesData.reduce(
        (acc, fileData, index) => ({
          ...acc,
          [files[index].name]: {
            size: files[index].size,
            rcdata: fileData.rcdata,
            name: files[index].name,
          },
        }),
        {},
      );

      attachFiles(filesNames, grid, finalData);
    }
  };

  const handleDrop = async function (e) {
    const grid = e.target.closest(".grid-panel").grid;
    e.stopPropagation();
    e.preventDefault();

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const files = Array.from(e.dataTransfer.files);
      const filesNames = files.map((file) => file.name);
      const filesData = await Promise.all(files.map((file) => getBase64ByFileReader(file)));
      const finalData = filesData.reduce(
        (acc, fileData, index) => ({
          ...acc,
          [files[index].name]: {
            size: files[index].size,
            rcdata: fileData.rcdata,
            name: files[index].name,
          },
        }),
        {},
      );

      attachFiles(filesNames, grid, finalData);
    }
  };

  function attachFiles(filesNames, grid, dataOfFiles) {
    let params = new Map();

    params
      .set("prefix", "documents")
      .set("comand", "AttachFiles")
      .set("DocCfgID", grid.doccfgid === "0" ? props.DocCfgID : grid.doccfgid)
      .set("SectionID", props.id)
      .set("DocID", grid.getActiveSource().getFieldTextSync("ID") || 0)
      .set("WSM", "1");
    if (grid.getActiveSource().Master && grid.getActiveSource().Master.MasterID) {
      params.set("MasterID", grid.getActiveSource().Master.MasterID);
    }
    AxiosRequest(true, params, { Files: filesNames }).then((answer) => {
      tokenProcessingTest(answer, {
        from: "grid",
        func: () => {
          AfterWSM(MainGridRef.current, {});
        },
        props: {
          files: dataOfFiles,
        },
      });
    });
  }

  /*

  <Result Module="documents" Token="RefreshDocument" Break="1">
    <Params DocCfgID="3008" SectionID="-1" RequestID="32952"/>
  </Result>

  */
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
  };

  const saveChanges = async () => {
    if (!!redactorRef.current) {
      await redactorRef.current.postExicstedEditRec();
      if (props.setRedactor) {
        props.setRedactor(false);
      } else {
        setRedactor(false);
      }
    }
    await CommitSaveOrCancelChanges();
  };

  const handleKeyS = async (e) => {
    if (
      (e.ctrlKey && !isEmptyObject(saveDocs.current) && !isEmptyObject(saveDocs.current[props.DocCfgID])) ||
      (redactorRef.current && e.ctrlKey)
    ) {
      e.preventDefault();
      await saveChanges();
    } else {
      e.stopPropagation();
    }
  };

  const onKeyDown = async (e) => {
    const countOfModals = CheckModalBackGrounds();
    if (countOfModals > 0 && !e.currentTarget.closest(".smart-window")) {
      e.stopPropagation();
      return;
    }
    // if (checkShortCuts(e)) {
    //   e.preventDefault();
    //   e.stopPropagation();
    //   return;
    // }
    // console.log(e);
    switch (e.code) {
      case "KeyS": {
        await handleKeyS(e);
        break;
      }
      case "KeyD":
        if (e.ctrlKey) {
          e.preventDefault();
          const activeElement = document.activeElement;
          activeElement.blur();
          setTimeout(() => {
            applyButton.current.click();
            if (activeElement && activeElement.tagName === "INPUT") {
              activeElement.focus();
              activeElement.select();
            }
          }, 100);
        } else {
          e.stopPropagation();
        }
        break;
      case "Enter": {
        if (e.shiftKey && MainGridRef.current) {
          e.preventDefault();
          ContextMenuHandler({ value: "Settings" }, MainGridRef.current);
        } else {
          e.stopPropagation();
        }
        break;
      }
      case "Tab": {
        if (e.ctrlKey === false && e.shiftKey === false) {
          e.preventDefault();
        }
        break;
      }
      default:
        if (checkShortCuts(e)) {
          e.preventDefault();
        } else {
          e.stopPropagation();
        }
    }
  };

  function setLastFocus() {
    if (!focusedGridRef.current) return;
    focusedGridRef.current.focus();
  }

  function checkShortCuts(e) {
    if (!isEmptyObject(shortsCutsData)) {
      let keyArr = [];
      if (e.ctrlKey) {
        keyArr.push(17);
      } else if (e.shiftKey) {
      }
      keyArr.push(e.keyCode);
      if (shortsCutsData.hasOwnProperty(keyArr)) {
        e.preventDefault();
        // e.stopPropagation();
        const shortCutElem = shortsCutsData[keyArr];
        if (shortCutElem && shortCutElem.ID) {
          const grid =
            shortCutElem.localdoccfgid === props.DocCfgID
              ? MainGridRef.current
              : me.current.querySelector("gridpanel" + shortCutElem.localdoccfgid);
          HandleToolButton(
            {
              currentTarget: {
                id: shortCutElem.ID,
                doccfgid: shortCutElem.localdoccfgid,
              },
            },
            grid,
          );
          return true;
        } else return false;
      } else return false;
    } else return false;
  }

  const showDocumentParams = !props.HideParams && showParams(DocumentLayout);
  const showDocumentTree = DocumentLayout !== undefined && DocumentLayout.HasTree === "1";
  const showDocumentSidePanel = showDocumentParams || showDocumentTree;

  return (
    <div style={{ display: "contents" }} tabIndex={"-1"} onKeyDown={onKeyDown} ref={me} id={"Documents" + props.id}>
      {portal}
      <GridLegacy
        style={{ height: "100%" }}
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        {props.SectionToolsJS === true && <SectionToolsJS ID={props.id} />}
        <SmetaSplitter
          key={showDocumentSidePanel ? "documents-with-side-panel" : "documents-without-side-panel"}
          splitterRef={leftSplitterRef}
          style={{
            width: "100%",
            borderTop: "1px solid rgb(208, 208, 208)",
            flex: "1 1",
          }}
          orientation="vertical"
          onExpand={onExpand}
          onCollapse={onCollapse}
          onResizeEnd={onResizeEnd}
          primaryIndex="end"
          blockResize={false}
        >
          {showDocumentSidePanel && (
            <SmetaSplitterItem
              size="20%"
              defaultCollapsed={props.collapsedParams !== undefined ? props.collapsedParams : false}
            >
              {showDocumentParams ? (
                <div id={"item_Param_" + props.id} style={{ height: "100%" }}>
                  <div
                    style={{
                      height: `calc(100% - 37px)`,
                      // overflow: "auto",
                    }}
                    id={"ParamsDoc" + props.id}
                  >
                    {ReturnParams(DocumentLayout)}
                  </div>

                  <Button
                    id="applyButton"
                    ref={applyButton}
                    style={{
                      marginBottom: "3px",
                      marginTop: "3px",
                      width: "126px",
                      height: 28,
                      textTransform: "none",
                      marginLeft: "6px",
                    }}
                    variant="outlined"
                    onClick={ApplyButtonClick}
                    className={clsx("buttonStimate", {
                      light: getTheme() === "light",
                    })}
                  >
                    Применить
                  </Button>
                </div>
              ) : null}
              {showDocumentTree ? (
                <div id={"item_Param_" + props.id} style={{ height: "100%" }}>
                  <div
                    style={{
                      height: `100%`,
                      overflow: "auto",
                    }}
                    id={"ParamsDoc" + props.id}
                  >
                    {tree}
                  </div>
                </div>
              ) : null}
            </SmetaSplitterItem>
          )}
          <SmetaSplitterItem>
            <div id={"item_Grid_" + props.id} style={{ height: "100%", width: "100%" }}>
              {DocumentLayout === undefined ? <LoadingMask /> : null}
              {props.HideControlButtons ? null : (
                <div style={{ height: "32px", width: "calc(100% - 0px)" }}>
                  <GridLegacy
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{ maxHeight: "36px" }}
                    className={clsx("backgroundColorStimate", {
                      light: getTheme() === "light",
                    })}
                  >
                    <GridLegacy item sx={{ height: "32px", ml: 1, flex: 1 }}>
                      <ButtonsForGridComponent
                        onClick={ControlButtonClick}
                        id={props.id}
                        grid={
                          MainGridRef.current && MainGridRef.current.grid
                            ? {
                                grid: MainGridRef.current.grid,
                                source: MainGridRef.current.grid.source,
                              }
                            : undefined
                        }
                        theme={getTheme()}
                        save={save[props.DocCfgID]}
                        redactor={redactor}
                        canModifyObj={canModifyObj}
                        selectedRecord={selectedRecordID}
                        buttons={controlButtons}
                        buttonsState={controlButtonsState}
                        DisableDetails={DocumentLayout !== undefined && isEmptyObject(DocumentLayout.Details)}
                      />
                      {samples.length > 0 ? (
                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl) && anchorEl.id === "appendButtonForGrid"}
                          onClose={handleCloseAnchorEl}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                        >
                          {Boolean(anchorEl) && anchorEl.id === "appendButtonForGrid"
                            ? MenuItems([...samples, { Caption: "-" }, { Name: "Новый документ" }], sampleMenuClick)
                            : null}
                        </Menu>
                      ) : null}

                      <Menu
                        anchorEl={anchorElButton}
                        open={Boolean(anchorElButton)}
                        onClose={handleCloseAnchorEl}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                      >
                        {DocumentLayout && DocumentLayout.Tools.Buttons && Boolean(anchorElButton)
                          ? MenuItems(
                              DocumentLayout.Tools.Buttons[anchorElButton.getAttribute("index")].items,
                              HandleToolButton,
                              GetMenuSt({ command: "GetMenuState" }),
                              GetDisable,
                              {
                                doccfgid: props.doccfgid,
                              },
                            )
                          : null}
                      </Menu>
                    </GridLegacy>
                    <GridLegacy item>
                      <SaveAsButton
                        reportModule={paperFormData.Module}
                        ViewIdent={selectedViewIdent}
                        style={{ display: selectedViewIdent ? "" : "none" }}
                      />
                    </GridLegacy>
                    <GridLegacy
                      item
                      sx={{ height: "100%", mr: 1, flex: "0 1 auto", display: "flex", justifyContent: "flex-end" }}
                    >
                      {DocumentLayout !== undefined && DocumentLayout.Forms && DocumentLayout.Forms.length > 0 ? (
                        <>
                          <Button
                            variant="outlined"
                            onClick={selectViewOfPaperForm}
                            id={"FormsButton" + props.id}
                            formid={DocumentLayout.Forms[0].ID}
                            style={{
                              borderRadius: "15px",
                              height: "20px",
                              textTransform: "none",
                            }}
                            className={clsx("buttonStimate", {
                              light: getTheme() === "light",
                            })}
                          >
                            Печатный вид
                          </Button>
                          <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl) && anchorEl.id === "FormsButton" + props.id}
                            onClose={handleCloseAnchorEl}
                            MenuListProps={{
                              "aria-labelledby": "basic-button",
                            }}
                          >
                            {formsList.length > 1
                              ? MenuItems(formsList, PaperForm, undefined, GetDisable, {
                                  doccfgid: props.doccfgid,
                                })
                              : null}
                          </Menu>
                        </>
                      ) : null}
                    </GridLegacy>
                  </GridLegacy>
                </div>
              )}
              <GridLegacy
                style={{
                  height: `calc(100% - ${props.HideControlButtons ? "0px" : "32px"})`,
                  width: "calc(100% - 5px)",
                  display: selectedView === "paper" ? "" : "none",
                }}
                id={"PaperFormDocuments" + props.id}
              >
                <div style={{ overflow: "hidden", height: "100%" }}>
                  <TabsForReports
                    reportData={paperFormData}
                    ID={props.id}
                    onViewIdentChange={setSelectedViewIdent}
                    groupId={props.DocCfgID}
                  />
                </div>
              </GridLegacy>

              <SmetaSplitter
                style={{
                  height: `calc(100% - ${props.HideControlButtons ? "0px" : "32px"})`,
                  width: "calc(100% - 5px)",
                  display: selectedView === "doc" || selectedView === "card" ? "" : "none",
                }}
                orientation="horizontal"
                onExpand={() => {
                  ChangeCollapsedDetails(false);
                }}
                onCollapse={() => {
                  ChangeCollapsedDetails(true);
                }}
                onResizeEnd={onResizeEnd}
                id={"MainSplitterOfDocumentsGrid" + props.id}
                blockResize={props.HideDetails}
                hideSplitter={DocumentLayout !== undefined && isEmptyObject(DocumentLayout.Details)}
                primaryIndex="start"
              >
                <SmetaSplitterItem size="60%" style={{ flexShrink: 1, minHeight: 0 }}>
                  <ContextMenu
                    for={"grid"}
                    data={MenuJson}
                    onRightClick={(dataFromContextMenu) => {
                      return GetMenu(
                        {
                          state: true,
                          status: DocumentLayout !== undefined && DocumentLayout.HasStatus === "1" ? true : false,
                        },
                        { ...DocumentLayout, ...dataFromContextMenu },
                      );
                    }}
                    onMenuItemClick={ContextMenuHandler}
                    docCfgID={props.DocCfgID}
                    id={props.id}
                    Details={props.HideControlButtons}
                  >
                    <LoadingMask bool={!loadMain} />
                    <div
                      id={"gridpanel" + props.DocCfgID}
                      ref={MainGridRef}
                      onFocus={onFocusChange}
                      tabIndex={"0"}
                      style={{
                        height: "100%",
                        width: "100%",
                      }}
                      rcsgrid_panel=""
                      onDragOver={handleDrag}
                      onDrop={handleDrop}
                    ></div>
                  </ContextMenu>
                </SmetaSplitterItem>
                <SmetaSplitterItem size="40%" collapsed={detailsBool} style={{ flexShrink: 1, minHeight: 0 }}>
                  <div id={"Details" + props.id} style={{ width: "100%", height: "100%" }}>
                    <div key={"tabsDocumentDetailsDiv" + props.id} style={{ height: "100%" }} onPaste={handlePaste}>
                      <ContextMenu
                        for={"grid"}
                        onRightClick={(dataFromContextMenu) => {
                          return GetMenu({ state: true }, { ...DocumentLayoutDetails, ...dataFromContextMenu });
                        }}
                        onMenuItemClick={ContextMenuHandler}
                        id={props.id}
                        data={{
                          Table: [
                            {
                              Caption: "Печать отмеченных записей",
                              value: "PrintSelectedRecords",
                            },
                          ],
                        }}
                      >
                        {/* React отвечает за вкладки и панели, legacy-грид создается внутри готового контейнера */}
                        <SectionDocumentDetails
                          documentLayout={DocumentLayout}
                          masterGrid={MainGridRef.current?.grid}
                          tabIndex={selectedTabIndex}
                          hiddenTabs={hiddenTabs}
                          detailsSplittersSizes={detailsSplittersSizes}
                          loading={loadDetails}
                          renderModule={renderDetailModule}
                          onTabIndexChange={(index, detailTab) => onTabChange(index, detailTab)}
                          onGridFocus={(panel) => onFocusChange({ currentTarget: panel })}
                          onSplitterResize={(splitter, detailTab) => detailsInDetailsSizeChange(splitter, detailTab)}
                        />
                      </ContextMenu>
                    </div>
                  </div>
                </SmetaSplitterItem>
              </SmetaSplitter>
            </div>
          </SmetaSplitterItem>
        </SmetaSplitter>
      </GridLegacy>
    </div>
  );
}
